// This file is auto-generated by @hey-api/openapi-ts

import type { Options as ClientOptions, TDataShape, Client } from '@hey-api/client-fetch';
import type { AccountAccountsListData, AccountAccountsListResponse, AccountAccountsCreateData, AccountAccountsCreateResponse, AccountAccountsDestroyData, AccountAccountsDestroyResponse, AccountAccountsRetrieveData, AccountAccountsRetrieveResponse, AccountAccountsPartialUpdateData, AccountAccountsPartialUpdateResponse, AccountAccountsUpdateData, AccountAccountsUpdateResponse, AccountAccountsOptInsUpdateData, AccountAccountsOptInsUpdateResponse, AccountUsersListData, AccountUsersListResponse, AccountUsersCreateData, AccountUsersCreateResponse, AccountUsersRetrieveData, AccountUsersRetrieveResponse, AccountUsersPartialUpdateData, AccountUsersPartialUpdateResponse, AccountUsersUpdateData, AccountUsersUpdateResponse, AccountUsersFeatureFlagsRetrieveData, AccountUsersFeatureFlagsRetrieveResponse, AccountUsersFeatureFlagsCreateData, AccountUsersFeatureFlagsCreateResponse, AccountUsersMeRetrieveData, AccountUsersMeRetrieveResponse, AccountUsersMePartialUpdateData, AccountUsersMePartialUpdateResponse, AccountUsersMeCreateData, AccountUsersMeCreateResponse, AccountUsersValidateCreateData, AccountUsersValidateCreateResponse, AgentsSimpleAgentThreadsListData, AgentsSimpleAgentThreadsListResponse, AgentsSimpleAgentThreadsCreateData, AgentsSimpleAgentThreadsCreateResponse, AgentsSimpleAgentThreadsDestroyData, AgentsSimpleAgentThreadsDestroyResponse, AgentsSimpleAgentThreadsRetrieveData, AgentsSimpleAgentThreadsRetrieveResponse, AgentsSimpleAgentThreadsPartialUpdateData, AgentsSimpleAgentThreadsPartialUpdateResponse, AgentsSimpleAgentThreadsUpdateData, AgentsSimpleAgentThreadsUpdateResponse, AgentsSimpleAgentsListData, AgentsSimpleAgentsListResponse, AgentsSimpleAgentsRetrieveData, AgentsSimpleAgentsRetrieveResponse, AnalyticsFeedbackCreateData, AnalyticsFeedbackCreateResponse, AnalyticsSurveyListData, AnalyticsSurveyListResponse, AnalyticsSurveyCreateData, AnalyticsSurveyCreateResponse, AnalyticsSurveyDestroyData, AnalyticsSurveyDestroyResponse, AnalyticsSurveyRetrieveData, AnalyticsSurveyRetrieveResponse, AnalyticsSurveyPartialUpdateData, AnalyticsSurveyPartialUpdateResponse, AnalyticsSurveyUpdateData, AnalyticsSurveyUpdateResponse, AnalyticsSurveyAiAnalysisListData, AnalyticsSurveyAiAnalysisListResponse, AnalyticsSurveyPrepareEmailContentRetrieveData, AnalyticsSurveyPrepareEmailContentRetrieveResponse, AnalyticsSurveyPublishCreateData, AnalyticsSurveyPublishCreateResponse, AnalyticsSurveyResultsListData, AnalyticsSurveyResultsListResponse, AppsAppsListData, AppsAppsListResponse, AppsAppsCreateData, AppsAppsCreateResponse, AppsAppsDestroyData, AppsAppsDestroyResponse, AppsAppsRetrieveData, AppsAppsRetrieveResponse, AppsAppsPartialUpdateData, AppsAppsPartialUpdateResponse, AppsAppsUpdateData, AppsAppsUpdateResponse, AppsDeploymentsListData, AppsDeploymentsListResponse, AppsDeploymentsInvokeCreateData, AppsDeploymentsInvokeCreateResponse, AppsDeploymentsInvokeCreate2Data, AppsDeploymentsInvokeCreate2Response, AppsInstalledAppsListData, AppsInstalledAppsListResponse, AppsInstalledAppsCreateData, AppsInstalledAppsCreateResponse, AppsInstalledAppsDestroyData, AppsInstalledAppsDestroyResponse, AppsInstalledAppsRetrieveData, AppsInstalledAppsRetrieveResponse, AppsInstalledAppsPartialUpdateData, AppsInstalledAppsPartialUpdateResponse, AppsInstalledAppsUpdateData, AppsInstalledAppsUpdateResponse, CampaignAssetsListData, CampaignAssetsListResponse, CampaignAssetsCreateData, CampaignAssetsCreateResponse, CampaignAssetsDestroyData, CampaignAssetsDestroyResponse, CampaignAssetsRetrieveData, CampaignAssetsRetrieveResponse, CampaignAssetsPartialUpdateData, CampaignAssetsPartialUpdateResponse, CampaignAssetsUpdateData, CampaignAssetsUpdateResponse, CampaignAudiencesListData, CampaignAudiencesListResponse, CampaignAudiencesCreateData, CampaignAudiencesCreateResponse, CampaignAudiencesDestroyData, CampaignAudiencesDestroyResponse, CampaignAudiencesRetrieveData, CampaignAudiencesRetrieveResponse, CampaignAudiencesPartialUpdateData, CampaignAudiencesPartialUpdateResponse, CampaignAudiencesUpdateData, CampaignAudiencesUpdateResponse, CampaignAudiencesEstimateMatchRateCreateData, CampaignCampaignsListData, CampaignCampaignsListResponse, CampaignCampaignsCreateData, CampaignCampaignsCreateResponse, CampaignCampaignsDestroyData, CampaignCampaignsDestroyResponse, CampaignCampaignsRetrieveData, CampaignCampaignsRetrieveResponse, CampaignCampaignsPartialUpdateData, CampaignCampaignsPartialUpdateResponse, CampaignCampaignsUpdateData, CampaignCampaignsUpdateResponse, CampaignContentTypesListData, CampaignContentTypesListResponse, CampaignContentTypesCreateData, CampaignContentTypesCreateResponse, CampaignContentTypesDestroyData, CampaignContentTypesDestroyResponse, CampaignContentTypesRetrieveData, CampaignContentTypesRetrieveResponse, CampaignContentTypesPartialUpdateData, CampaignContentTypesPartialUpdateResponse, CampaignContentTypesUpdateData, CampaignContentTypesUpdateResponse, ConfigClientsListData, ConfigClientsListResponse, ConfigClientsCreateData, ConfigClientsCreateResponse, ConfigClientsDestroyData, ConfigClientsDestroyResponse, ConfigClientsRetrieveData, ConfigClientsRetrieveResponse, ConfigClientsPartialUpdateData, ConfigClientsPartialUpdateResponse, ConfigClientsUpdateData, ConfigClientsUpdateResponse, ConfigClientsDetailsRetrieveData, ConfigClientsDetailsRetrieveResponse, ConfigClientsLanguagesRetrieveData, ConfigClientsLanguagesRetrieveResponse, ConfigClientsLookupRetrieveData, ConfigClientsLookupRetrieveResponse, ConfigCouriersListData, ConfigCouriersListResponse, ConfigCouriersCreateData, ConfigCouriersCreateResponse, ConfigCouriersDestroyData, ConfigCouriersDestroyResponse, ConfigCouriersRetrieveData, ConfigCouriersRetrieveResponse, ConfigCouriersPartialUpdateData, ConfigCouriersPartialUpdateResponse, ConfigCouriersUpdateData, ConfigCouriersUpdateResponse, ConfigFilterFieldsListData, ConfigFilterFieldsListResponse, ConfigFilterFieldsCreateData, ConfigFilterFieldsCreateResponse, ConfigFilterFieldsDestroyData, ConfigFilterFieldsDestroyResponse, ConfigFilterFieldsRetrieveData, ConfigFilterFieldsRetrieveResponse, ConfigFilterFieldsPartialUpdateData, ConfigFilterFieldsPartialUpdateResponse, ConfigFilterFieldsUpdateData, ConfigFilterFieldsUpdateResponse, ConfigIntegrationsListData, ConfigIntegrationsListResponse, ConfigIntegrationsCreateData, ConfigIntegrationsCreateResponse, ConfigIntegrationsDestroyData, ConfigIntegrationsDestroyResponse, ConfigIntegrationsRetrieveData, ConfigIntegrationsRetrieveResponse, ConfigIntegrationsPartialUpdateData, ConfigIntegrationsPartialUpdateResponse, ConfigIntegrationsUpdateData, ConfigIntegrationsUpdateResponse, ConfigReferenceItemsListData, ConfigReferenceItemsListResponse, ConfigReferenceItemsCreateData, ConfigReferenceItemsCreateResponse, ConfigReferenceItemsDestroyData, ConfigReferenceItemsDestroyResponse, ConfigReferenceItemsRetrieveData, ConfigReferenceItemsRetrieveResponse, ConfigReferenceItemsPartialUpdateData, ConfigReferenceItemsPartialUpdateResponse, ConfigReferenceItemsUpdateData, ConfigReferenceItemsUpdateResponse, ConfigSmsAutoreplyConfigListData, ConfigSmsAutoreplyConfigListResponse, ConfigSmsAutoreplyConfigCreateData, ConfigSmsAutoreplyConfigCreateResponse, ConfigSmsAutoreplyConfigDestroyData, ConfigSmsAutoreplyConfigDestroyResponse, ConfigSmsAutoreplyConfigRetrieveData, ConfigSmsAutoreplyConfigRetrieveResponse, ConfigSmsAutoreplyConfigPartialUpdateData, ConfigSmsAutoreplyConfigPartialUpdateResponse, ConfigSmsAutoreplyConfigUpdateData, ConfigSmsAutoreplyConfigUpdateResponse, ConfigWhitelabelDomainConfigsListData, ConfigWhitelabelDomainConfigsListResponse, ConfigWhitelabelDomainConfigsRetrieveData, ConfigWhitelabelDomainConfigsRetrieveResponse, ConfigWhitelistedDomainsListData, ConfigWhitelistedDomainsListResponse, ConfigWhitelistedDomainsCreateData, ConfigWhitelistedDomainsCreateResponse, ConfigWhitelistedDomainsDestroyData, ConfigWhitelistedDomainsDestroyResponse, ConfigWhitelistedDomainsBulkCreateCreateData, ConfigWhitelistedDomainsBulkCreateCreateResponse, ConfigWhitelistedDomainsLookupRetrieveData, ConfigWhitelistedDomainsLookupRetrieveResponse, ImportsListData, ImportsListResponse, ImportsCreateData, ImportsCreateResponse, ImportsRetrieveData, ImportsRetrieveResponse, InAppMessageContentBlocksDismissPartialUpdateData, InAppMessageContentBlocksDismissPartialUpdateResponse, InAppMessageContentBlocksDismissPartialUpdateError, InAppMessageContentBlocksByLocationListData, InAppMessageContentBlocksByLocationListResponse, JourneyConfigurationsListData, JourneyConfigurationsListResponse, JourneyConfigurationsCreateData, JourneyConfigurationsCreateResponse, JourneyConfigurationsDestroyData, JourneyConfigurationsDestroyResponse, JourneyConfigurationsRetrieveData, JourneyConfigurationsRetrieveResponse, JourneyConfigurationsPartialUpdateData, JourneyConfigurationsPartialUpdateResponse, JourneyConfigurationsUpdateData, JourneyConfigurationsUpdateResponse, JourneyConfigurationsPublishCreateData, JourneyConfigurationsPublishCreateResponse, JourneyConfigurationsFlowAnalysisRetrieveData, JourneyConfigurationsFlowAnalysisRetrieveResponse, JourneyConfigurationsLookupRetrieveData, JourneyConfigurationsLookupRetrieveResponse, JourneyEventsListData, JourneyEventsListResponse, JourneyEventsCreateData, JourneyEventsCreateResponse, JourneyEventsDestroyData, JourneyEventsDestroyResponse, JourneyEventsRetrieveData, JourneyEventsRetrieveResponse, JourneyEventsPartialUpdateData, JourneyEventsPartialUpdateResponse, JourneyEventsUpdateData, JourneyEventsUpdateResponse, JourneyExperimentsListData, JourneyExperimentsListResponse, JourneyExperimentsCreateData, JourneyExperimentsCreateResponse, JourneyExperimentsDestroyData, JourneyExperimentsDestroyResponse, JourneyExperimentsRetrieveData, JourneyExperimentsRetrieveResponse, JourneyExperimentsPartialUpdateData, JourneyExperimentsPartialUpdateResponse, JourneyExperimentsUpdateData, JourneyExperimentsUpdateResponse, JourneyExperimentsPublishCreateData, JourneyExperimentsPublishCreateResponse, JourneyExperimentsResultsListData, JourneyExperimentsResultsListResponse, JourneyExperimentsWinnerVariantPartialUpdateData, JourneyExperimentsWinnerVariantPartialUpdateResponse, JourneyFlowVisualizationsListData, JourneyFlowVisualizationsListResponse, JourneyFlowVisualizationsCreateData, JourneyFlowVisualizationsCreateResponse, JourneyFlowVisualizationsDestroyData, JourneyFlowVisualizationsDestroyResponse, JourneyFlowVisualizationsRetrieveData, JourneyFlowVisualizationsRetrieveResponse, JourneyFlowVisualizationsPartialUpdateData, JourneyFlowVisualizationsPartialUpdateResponse, JourneyFlowVisualizationsUpdateData, JourneyFlowVisualizationsUpdateResponse, JourneyLayoutsListData, JourneyLayoutsListResponse, JourneyLayoutsCreateData, JourneyLayoutsCreateResponse, JourneyLayoutsDestroyData, JourneyLayoutsDestroyResponse, JourneyLayoutsRetrieveData, JourneyLayoutsRetrieveResponse, JourneyLayoutsPartialUpdateData, JourneyLayoutsPartialUpdateResponse, JourneyLayoutsUpdateData, JourneyLayoutsUpdateResponse, JourneyLayoutsDetailsRetrieveData, JourneyLayoutsDetailsRetrieveResponse, JourneyLayoutsEditorConfigRetrieveData, JourneyLayoutsEditorConfigRetrieveResponse, JourneyLayoutsHistoryRetrieveData, JourneyLayoutsHistoryRetrieveResponse, JourneyLayoutsHistoryRetrieve2Data, JourneyLayoutsHistoryRetrieve2Response, JourneyLayoutsPublishCreateData, JourneyLayoutsPublishCreateResponse, JourneyLayoutsRevertCreateData, JourneyLayoutsRevertCreateResponse, JourneyLayoutsDeletedRetrieveData, JourneyLayoutsDeletedRetrieveResponse, JourneyMediasListData, JourneyMediasListResponse, JourneyMediasCreateData, JourneyMediasCreateResponse, JourneyMediasDestroyData, JourneyMediasDestroyResponse, JourneyMediasRetrieveData, JourneyMediasRetrieveResponse, JourneyMediasPartialUpdateData, JourneyMediasPartialUpdateResponse, JourneyMediasUpdateData, JourneyMediasUpdateResponse, JourneyMessageTypesListData, JourneyMessageTypesListResponse, JourneyMessageTypesCreateData, JourneyMessageTypesCreateResponse, JourneyMessageTypesDestroyData, JourneyMessageTypesDestroyResponse, JourneyMessageTypesRetrieveData, JourneyMessageTypesRetrieveResponse, JourneyMessageTypesPartialUpdateData, JourneyMessageTypesPartialUpdateResponse, JourneyMessageTypesUpdateData, JourneyMessageTypesUpdateResponse, JourneyMessageTypesAiGenerateCreateData, JourneyMessageTypesAiGenerateCreateResponse, JourneyMessagesListData, JourneyMessagesListResponse, JourneyMessagesCreateData, JourneyMessagesCreateResponse, JourneyMessagesDestroyData, JourneyMessagesDestroyResponse, JourneyMessagesRetrieveData, JourneyMessagesRetrieveResponse, JourneyMessagesPartialUpdateData, JourneyMessagesPartialUpdateResponse, JourneyMessagesUpdateData, JourneyMessagesUpdateResponse, JourneyMessagesDetailsRetrieveData, JourneyMessagesDetailsRetrieveResponse, JourneyMessagesEditorConfigRetrieveData, JourneyMessagesEditorConfigRetrieveResponse, JourneyMessagesHistoryRetrieveData, JourneyMessagesHistoryRetrieveResponse, JourneyMessagesHistoryRetrieve2Data, JourneyMessagesHistoryRetrieve2Response, JourneyMessagesPublishCreateData, JourneyMessagesPublishCreateResponse, JourneyMessagesRevertCreateData, JourneyMessagesRevertCreateResponse, JourneyMessagesTestCreateData, JourneyMessagesTestCreateResponse, JourneyMessagesTestWebhookCreateData, JourneyMessagesAiTranslateCreateData, JourneyMessagesAiTranslateCreateResponse, JourneyMessagesDeletedRetrieveData, JourneyMessagesDeletedRetrieveResponse, JourneyMessagesGenerateRetrieveData, JourneyMessagesGenerateRetrieveResponse, JourneyMessagesMigrateCreateData, JourneyMessagesMigrateCreateResponse, JourneyPartialsListData, JourneyPartialsListResponse, JourneyPartialsCreateData, JourneyPartialsCreateResponse, JourneyPartialsDestroyData, JourneyPartialsDestroyResponse, JourneyPartialsRetrieveData, JourneyPartialsRetrieveResponse, JourneyPartialsPartialUpdateData, JourneyPartialsPartialUpdateResponse, JourneyPartialsUpdateData, JourneyPartialsUpdateResponse, JourneyPartialsEditorConfigRetrieveData, JourneyPartialsEditorConfigRetrieveResponse, JourneyPartialsHistoryRetrieveData, JourneyPartialsHistoryRetrieveResponse, JourneyPartialsHistoryRetrieve2Data, JourneyPartialsHistoryRetrieve2Response, JourneyPartialsPublishCreateData, JourneyPartialsPublishCreateResponse, JourneyPartialsRevertCreateData, JourneyPartialsRevertCreateResponse, JourneyPartialsDeletedRetrieveData, JourneyPartialsDeletedRetrieveResponse, JourneyPlaceholdersListData, JourneyPlaceholdersListResponse, JourneyPlaceholdersCreateData, JourneyPlaceholdersCreateResponse, JourneyPlaceholdersDestroyData, JourneyPlaceholdersDestroyResponse, JourneyPlaceholdersRetrieveData, JourneyPlaceholdersRetrieveResponse, JourneyPlaceholdersPartialUpdateData, JourneyPlaceholdersPartialUpdateResponse, JourneyPlaceholdersUpdateData, JourneyPlaceholdersUpdateResponse, JourneySharedFiltersListData, JourneySharedFiltersListResponse, JourneySharedFiltersCreateData, JourneySharedFiltersCreateResponse, JourneySharedFiltersDestroyData, JourneySharedFiltersDestroyResponse, JourneySharedFiltersRetrieveData, JourneySharedFiltersRetrieveResponse, JourneySharedFiltersPartialUpdateData, JourneySharedFiltersPartialUpdateResponse, JourneySharedFiltersUpdateData, JourneySharedFiltersUpdateResponse, JourneyTriggersListData, JourneyTriggersListResponse, JourneyTriggersCreateData, JourneyTriggersCreateResponse, JourneyTriggersDestroyData, JourneyTriggersDestroyResponse, JourneyTriggersRetrieveData, JourneyTriggersRetrieveResponse, JourneyTriggersPartialUpdateData, JourneyTriggersPartialUpdateResponse, JourneyTriggersUpdateData, JourneyTriggersUpdateResponse, NotificationsNotificationListData, NotificationsNotificationListResponse, NotificationsNotificationCreateData, NotificationsNotificationCreateResponse, NotificationsNotificationDestroyData, NotificationsNotificationDestroyResponse, NotificationsNotificationRetrieveData, NotificationsNotificationRetrieveResponse, NotificationsNotificationPartialUpdateData, NotificationsNotificationPartialUpdateResponse, NotificationsNotificationUpdateData, NotificationsNotificationUpdateResponse, PortalCustomAnalyticsListData, PortalCustomAnalyticsListResponse, PortalCustomAnalyticsCreateData, PortalCustomAnalyticsCreateResponse, PortalCustomAnalyticsDestroyData, PortalCustomAnalyticsDestroyResponse, PortalCustomAnalyticsRetrieveData, PortalCustomAnalyticsRetrieveResponse, PortalCustomAnalyticsPartialUpdateData, PortalCustomAnalyticsPartialUpdateResponse, PortalCustomAnalyticsUpdateData, PortalCustomAnalyticsUpdateResponse, PortalCustomAnalyticsIframeRetrieveData, PortalCustomAnalyticsIframeRetrieveResponse, PortalCustomerPortalsListData, PortalCustomerPortalsListResponse, PortalCustomerPortalsCreateData, PortalCustomerPortalsCreateResponse, PortalCustomerPortalsDestroyData, PortalCustomerPortalsDestroyResponse, PortalCustomerPortalsRetrieveData, PortalCustomerPortalsRetrieveResponse, PortalCustomerPortalsPartialUpdateData, PortalCustomerPortalsPartialUpdateResponse, PortalCustomerPortalsUpdateData, PortalCustomerPortalsUpdateResponse, PortalDataProtectionRequestsListData, PortalDataProtectionRequestsListResponse, PortalDataProtectionRequestsCreateData, PortalDataProtectionRequestsCreateResponse, PortalDataProtectionRequestsDestroyData, PortalDataProtectionRequestsDestroyResponse, PortalDataProtectionRequestsRetrieveData, PortalDataProtectionRequestsRetrieveResponse, PortalDataProtectionRequestsPartialUpdateData, PortalDataProtectionRequestsPartialUpdateResponse, PortalDataProtectionRequestsUpdateData, PortalDataProtectionRequestsUpdateResponse, PortalDataProtectionRequestsBulkCreateData, PortalDataProtectionRequestsBulkCreateResponse, PortalReportEmbedTokenTokenCreateData, PortalReportEmbedTokenTokenCreateResponse, PortalReportsListData, PortalReportsListResponse, PortalReportsCreateData, PortalReportsCreateResponse, PortalReportsDestroyData, PortalReportsDestroyResponse, PortalReportsRetrieveData, PortalReportsRetrieveResponse, PortalReportsPartialUpdateData, PortalReportsPartialUpdateResponse, PortalReportsUpdateData, PortalReportsUpdateResponse, PortalSharedObjectsListData, PortalSharedObjectsListResponse, PortalSharedObjectsCreateData, PortalSharedObjectsCreateResponse, PortalSharedObjectsDestroyData, PortalSharedObjectsDestroyResponse, PortalSharedObjectsRetrieveData, PortalSharedObjectsRetrieveResponse, PortalSharedObjectsPartialUpdateData, PortalSharedObjectsPartialUpdateResponse, PortalSharedObjectsUpdateData, PortalSharedObjectsUpdateResponse, PromiseCourierServiceLevelsListData, PromiseCourierServiceLevelsListResponse, PromiseCourierServiceLevelsCreateData, PromiseCourierServiceLevelsCreateResponse, PromiseCourierServiceLevelsDestroyData, PromiseCourierServiceLevelsDestroyResponse, PromiseCourierServiceLevelsRetrieveData, PromiseCourierServiceLevelsRetrieveResponse, PromiseCourierServiceLevelsPartialUpdateData, PromiseCourierServiceLevelsPartialUpdateResponse, PromiseCourierServiceLevelsUpdateData, PromiseCourierServiceLevelsUpdateResponse, PromiseDeliveryMethodsListData, PromiseDeliveryMethodsListResponse, PromiseDeliveryMethodsCreateData, PromiseDeliveryMethodsCreateResponse, PromiseDeliveryMethodsDestroyData, PromiseDeliveryMethodsDestroyResponse, PromiseDeliveryMethodsRetrieveData, PromiseDeliveryMethodsRetrieveResponse, PromiseDeliveryMethodsPartialUpdateData, PromiseDeliveryMethodsPartialUpdateResponse, PromiseDeliveryMethodsUpdateData, PromiseDeliveryMethodsUpdateResponse, PromiseDeliveryPredictionServicesListData, PromiseDeliveryPredictionServicesListResponse, PromiseDeliveryPredictionServicesCreateData, PromiseDeliveryPredictionServicesCreateResponse, PromiseDeliveryPredictionServicesDestroyData, PromiseDeliveryPredictionServicesDestroyResponse, PromiseDeliveryPredictionServicesRetrieveData, PromiseDeliveryPredictionServicesRetrieveResponse, PromiseDeliveryPredictionServicesPartialUpdateData, PromiseDeliveryPredictionServicesPartialUpdateResponse, PromiseDeliveryPredictionServicesUpdateData, PromiseDeliveryPredictionServicesUpdateResponse, PromiseDeliveryPredictionServicesPublishCreateData, PromiseDeliveryPredictionServicesPublishCreateResponse, PromiseDeliveryPredictionServicesPublishedRetrieveData, PromiseDeliveryPredictionServicesPublishedRetrieveResponse, PromiseTrendingDelayConfigurationsListData, PromiseTrendingDelayConfigurationsListResponse, PromiseTrendingDelayConfigurationsCreateData, PromiseTrendingDelayConfigurationsCreateResponse, PromiseTrendingDelayConfigurationsDestroyData, PromiseTrendingDelayConfigurationsDestroyResponse, PromiseTrendingDelayConfigurationsRetrieveData, PromiseTrendingDelayConfigurationsRetrieveResponse, PromiseTrendingDelayConfigurationsPartialUpdateData, PromiseTrendingDelayConfigurationsPartialUpdateResponse, PromiseTrendingDelayConfigurationsUpdateData, PromiseTrendingDelayConfigurationsUpdateResponse, PromiseWarehousesListData, PromiseWarehousesListResponse, PromiseWarehousesCreateData, PromiseWarehousesCreateResponse, PromiseWarehousesDestroyData, PromiseWarehousesDestroyResponse, PromiseWarehousesRetrieveData, PromiseWarehousesRetrieveResponse, PromiseWarehousesPartialUpdateData, PromiseWarehousesPartialUpdateResponse, PromiseWarehousesUpdateData, PromiseWarehousesUpdateResponse, ReturnsCourierApisListData, ReturnsCourierApisListResponse, ReturnsCourierApisCreateData, ReturnsCourierApisCreateResponse, ReturnsCourierApisDestroyData, ReturnsCourierApisDestroyResponse, ReturnsCourierApisRetrieveData, ReturnsCourierApisRetrieveResponse, ReturnsCourierApisPartialUpdateData, ReturnsCourierApisPartialUpdateResponse, ReturnsCourierApisUpdateData, ReturnsCourierApisUpdateResponse, ReturnsCourierApisSchemaRetrieveData, ReturnsDocumentTemplatesListData, ReturnsDocumentTemplatesListResponse, ReturnsDocumentTemplatesCreateData, ReturnsDocumentTemplatesCreateResponse, ReturnsDocumentTemplatesDestroyData, ReturnsDocumentTemplatesDestroyResponse, ReturnsDocumentTemplatesRetrieveData, ReturnsDocumentTemplatesRetrieveResponse, ReturnsDocumentTemplatesPartialUpdateData, ReturnsDocumentTemplatesPartialUpdateResponse, ReturnsDocumentTemplatesUpdateData, ReturnsDocumentTemplatesUpdateResponse, ReturnsDocumentTemplatesPublishCreateData, ReturnsDocumentTemplatesPublishCreateResponse, ReturnsDocumentTemplatesLookupRetrieveData, ReturnsDocumentTemplatesLookupRetrieveResponse, ReturnsOrderApisListData, ReturnsOrderApisListResponse, ReturnsOrderApisCreateData, ReturnsOrderApisCreateResponse, ReturnsOrderApisDestroyData, ReturnsOrderApisDestroyResponse, ReturnsOrderApisRetrieveData, ReturnsOrderApisRetrieveResponse, ReturnsOrderApisPartialUpdateData, ReturnsOrderApisPartialUpdateResponse, ReturnsOrderApisUpdateData, ReturnsOrderApisUpdateResponse, ReturnsOrderApisSchemaRetrieveData, ReturnsPortalsListData, ReturnsPortalsListResponse, ReturnsPortalsCreateData, ReturnsPortalsCreateResponse, ReturnsPortalsDestroyData, ReturnsPortalsDestroyResponse, ReturnsPortalsRetrieveData, ReturnsPortalsRetrieveResponse, ReturnsPortalsPartialUpdateData, ReturnsPortalsPartialUpdateResponse, ReturnsPortalsUpdateData, ReturnsPortalsUpdateResponse, ReturnsPortalsDetailsRetrieveData, ReturnsPortalsDetailsRetrieveResponse, ReturnsPortalsPublishCreateData, ReturnsPortalsPublishCreateResponse, ReturnsPortalsSchemaRetrieveData, ReturnsPortalsLookupRetrieveData, ReturnsPortalsLookupRetrieveResponse, ReturnsReturnReasonsListData, ReturnsReturnReasonsListResponse, ReturnsReturnReasonsCreateData, ReturnsReturnReasonsCreateResponse, ReturnsReturnReasonsDestroyData, ReturnsReturnReasonsDestroyResponse, ReturnsReturnReasonsRetrieveData, ReturnsReturnReasonsRetrieveResponse, ReturnsReturnReasonsPartialUpdateData, ReturnsReturnReasonsPartialUpdateResponse, ReturnsReturnReasonsUpdateData, ReturnsReturnReasonsUpdateResponse, ReturnsReturnReasonsMoveToCreateData, ReturnsReturnReasonsMoveToCreateResponse, ReturnsReturnRegistrationsListData, ReturnsReturnRegistrationsListResponse, ReturnsReturnRegistrationsCreateData, ReturnsReturnRegistrationsCreateResponse, ReturnsReturnRegistrationsDestroyData, ReturnsReturnRegistrationsDestroyResponse, ReturnsReturnRegistrationsRetrieveData, ReturnsReturnRegistrationsRetrieveResponse, ReturnsReturnRegistrationsPartialUpdateData, ReturnsReturnRegistrationsPartialUpdateResponse, ReturnsReturnRegistrationsUpdateData, ReturnsReturnRegistrationsUpdateResponse, ReturnsReturnRegistrationsStatusCreateData, ReturnsReturnRegistrationsStatusCreateResponse, ReturnsRulesListData, ReturnsRulesListResponse, ReturnsRulesCreateData, ReturnsRulesCreateResponse, ReturnsRulesDestroyData, ReturnsRulesDestroyResponse, ReturnsRulesRetrieveData, ReturnsRulesRetrieveResponse, ReturnsRulesPartialUpdateData, ReturnsRulesPartialUpdateResponse, ReturnsRulesUpdateData, ReturnsRulesUpdateResponse, ReturnsTranslationsListData, ReturnsTranslationsListResponse, ReturnsTranslationsCreateData, ReturnsTranslationsCreateResponse, ReturnsTranslationsDestroyData, ReturnsTranslationsDestroyResponse, ReturnsTranslationsRetrieveData, ReturnsTranslationsRetrieveResponse, ReturnsTranslationsPartialUpdateData, ReturnsTranslationsPartialUpdateResponse, ReturnsTranslationsUpdateData, ReturnsTranslationsUpdateResponse, ReturnsTranslationsSchemaRetrieveData, ServicePublishedConfigurationsListData, ServicePublishedConfigurationsListResponse, ServicePublishedConfigurationsCreateData, ServicePublishedConfigurationsCreateResponse, ServicePublishedConfigurationsDestroyData, ServicePublishedConfigurationsDestroyResponse, ServicePublishedConfigurationsRetrieveData, ServicePublishedConfigurationsRetrieveResponse, ServicePublishedConfigurationsPartialUpdateData, ServicePublishedConfigurationsPartialUpdateResponse, ServicePublishedConfigurationsUpdateData, ServicePublishedConfigurationsUpdateResponse, ServiceRecipesListData, ServiceRecipesListResponse, ServiceRecipesRetrieveData, ServiceRecipesRetrieveResponse, ServiceRecipesApplyCreateData, ServiceRecipesApplyCreateResponse, ServiceRecipesApplicationsListData, ServiceRecipesApplicationsListResponse, ServiceRecipesApplicationsRetrieveData, ServiceRecipesApplicationsRetrieveResponse, ServiceRecipesApplicationsPublishCreateData, ServiceRecipesApplicationsPublishCreateResponse, ServiceServicesListData, ServiceServicesListResponse, ServiceServicesCreateData, ServiceServicesCreateResponse, ServiceServicesDestroyData, ServiceServicesDestroyResponse, ServiceServicesRetrieveData, ServiceServicesRetrieveResponse, ServiceServicesPartialUpdateData, ServiceServicesPartialUpdateResponse, ServiceServicesUpdateData, ServiceServicesUpdateResponse, ServiceServicesSchemaRetrieveData, ServiceServicesSchemaRetrieveResponse, TestappTestListData, TestappTestListResponse, TestappTestCreateData, TestappTestCreateResponse, TestappTestDestroyData, TestappTestDestroyResponse, TestappTestRetrieveData, TestappTestRetrieveResponse, TestappTestPartialUpdateData, TestappTestPartialUpdateResponse, TestappTestUpdateData, TestappTestUpdateResponse, TestappTestRaiseErrorRetrieveData, TestappTestRaiseErrorRetrieveResponse, TrackEmailsListData, TrackEmailsListResponse, TrackEmailsRetrieveData, TrackEmailsRetrieveResponse, TrackEventsListData, TrackEventsListResponse, TrackEventsRetrieveData, TrackEventsRetrieveResponse, TrackEventsAvailableTypesRetrieveData, TrackEventsAvailableTypesRetrieveResponse, TrackOrderStatusPagesListData, TrackOrderStatusPagesListResponse, TrackOrderStatusPagesCreateData, TrackOrderStatusPagesCreateResponse, TrackOrderStatusPagesDestroyData, TrackOrderStatusPagesDestroyResponse, TrackOrderStatusPagesRetrieveData, TrackOrderStatusPagesRetrieveResponse, TrackOrderStatusPagesPartialUpdateData, TrackOrderStatusPagesPartialUpdateResponse, TrackOrderStatusPagesUpdateData, TrackOrderStatusPagesUpdateResponse, TrackPlaceInfoListData, TrackPlaceInfoListResponse, TrackPlaceInfoCreateData, TrackPlaceInfoCreateResponse, TrackPlaceInfoDestroyData, TrackPlaceInfoDestroyResponse, TrackPlaceInfoRetrieveData, TrackPlaceInfoRetrieveResponse, TrackPlaceInfoPartialUpdateData, TrackPlaceInfoPartialUpdateResponse, TrackPlaceInfoUpdateData, TrackPlaceInfoUpdateResponse, TrackPlaceInfoLookupCreateData, TrackPlaceInfoLookupCreateResponse, TrackRecipientsListData, TrackRecipientsListResponse, TrackRecipientsRetrieveData, TrackRecipientsRetrieveResponse, TrackTrackingsListData, TrackTrackingsListResponse, TrackTrackingsRetrieveData, TrackTrackingsRetrieveResponse } from './types.gen';
import { client as _heyApiClient } from './client.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = ClientOptions<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * Resource REST API
 */
export const accountAccountsList = <ThrowOnError extends boolean = false>(options?: Options<AccountAccountsListData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<AccountAccountsListResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/account/accounts/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const accountAccountsCreate = <ThrowOnError extends boolean = false>(options: Options<AccountAccountsCreateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<AccountAccountsCreateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/account/accounts/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const accountAccountsDestroy = <ThrowOnError extends boolean = false>(options: Options<AccountAccountsDestroyData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<AccountAccountsDestroyResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/account/accounts/{id}/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const accountAccountsRetrieve = <ThrowOnError extends boolean = false>(options: Options<AccountAccountsRetrieveData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<AccountAccountsRetrieveResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/account/accounts/{id}/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const accountAccountsPartialUpdate = <ThrowOnError extends boolean = false>(options: Options<AccountAccountsPartialUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<AccountAccountsPartialUpdateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/account/accounts/{id}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const accountAccountsUpdate = <ThrowOnError extends boolean = false>(options: Options<AccountAccountsUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<AccountAccountsUpdateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/account/accounts/{id}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const accountAccountsOptInsUpdate = <ThrowOnError extends boolean = false>(options: Options<AccountAccountsOptInsUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<AccountAccountsOptInsUpdateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/account/accounts/{id}/opt-ins/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * API endpoint that allows Audiences to be viewed or edited.
 */
export const accountUsersList = <ThrowOnError extends boolean = false>(options?: Options<AccountUsersListData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<AccountUsersListResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/account/users/',
        ...options
    });
};

/**
 * API endpoint that allows Audiences to be viewed or edited.
 */
export const accountUsersCreate = <ThrowOnError extends boolean = false>(options: Options<AccountUsersCreateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<AccountUsersCreateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/account/users/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * API endpoint that allows Audiences to be viewed or edited.
 */
export const accountUsersRetrieve = <ThrowOnError extends boolean = false>(options: Options<AccountUsersRetrieveData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<AccountUsersRetrieveResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/account/users/{id}/',
        ...options
    });
};

/**
 * API endpoint that allows Audiences to be viewed or edited.
 */
export const accountUsersPartialUpdate = <ThrowOnError extends boolean = false>(options: Options<AccountUsersPartialUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<AccountUsersPartialUpdateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/account/users/{id}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * API endpoint that allows Audiences to be viewed or edited.
 */
export const accountUsersUpdate = <ThrowOnError extends boolean = false>(options: Options<AccountUsersUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<AccountUsersUpdateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/account/users/{id}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * (Internal) endpoint for managing user feature flags
 */
export const accountUsersFeatureFlagsRetrieve = <ThrowOnError extends boolean = false>(options?: Options<AccountUsersFeatureFlagsRetrieveData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<AccountUsersFeatureFlagsRetrieveResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/account/users/feature-flags/',
        ...options
    });
};

/**
 * (Internal) endpoint for managing user feature flags
 */
export const accountUsersFeatureFlagsCreate = <ThrowOnError extends boolean = false>(options?: Options<AccountUsersFeatureFlagsCreateData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<AccountUsersFeatureFlagsCreateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/account/users/feature-flags/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Get or update details of a user
 */
export const accountUsersMeRetrieve = <ThrowOnError extends boolean = false>(options?: Options<AccountUsersMeRetrieveData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<AccountUsersMeRetrieveResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/account/users/me/',
        ...options
    });
};

/**
 * API endpoint that allows Audiences to be viewed or edited.
 */
export const accountUsersMePartialUpdate = <ThrowOnError extends boolean = false>(options?: Options<AccountUsersMePartialUpdateData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).patch<AccountUsersMePartialUpdateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/account/users/me/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Get or update details of a user
 */
export const accountUsersMeCreate = <ThrowOnError extends boolean = false>(options?: Options<AccountUsersMeCreateData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<AccountUsersMeCreateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/account/users/me/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Legacy Portal Feature: validates a login and returns a JWT token
 */
export const accountUsersValidateCreate = <ThrowOnError extends boolean = false>(options: Options<AccountUsersValidateCreateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<AccountUsersValidateCreateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/account/users/validate/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * ViewSet for managing SimpleAgentThreads with filtering by agent-id and user-id.
 */
export const agentsSimpleAgentThreadsList = <ThrowOnError extends boolean = false>(options?: Options<AgentsSimpleAgentThreadsListData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<AgentsSimpleAgentThreadsListResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/agents/simple-agent-threads/',
        ...options
    });
};

/**
 * ViewSet for managing SimpleAgentThreads with filtering by agent-id and user-id.
 */
export const agentsSimpleAgentThreadsCreate = <ThrowOnError extends boolean = false>(options: Options<AgentsSimpleAgentThreadsCreateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<AgentsSimpleAgentThreadsCreateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/agents/simple-agent-threads/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * ViewSet for managing SimpleAgentThreads with filtering by agent-id and user-id.
 */
export const agentsSimpleAgentThreadsDestroy = <ThrowOnError extends boolean = false>(options: Options<AgentsSimpleAgentThreadsDestroyData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<AgentsSimpleAgentThreadsDestroyResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/agents/simple-agent-threads/{id}/',
        ...options
    });
};

/**
 * ViewSet for managing SimpleAgentThreads with filtering by agent-id and user-id.
 */
export const agentsSimpleAgentThreadsRetrieve = <ThrowOnError extends boolean = false>(options: Options<AgentsSimpleAgentThreadsRetrieveData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<AgentsSimpleAgentThreadsRetrieveResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/agents/simple-agent-threads/{id}/',
        ...options
    });
};

/**
 * ViewSet for managing SimpleAgentThreads with filtering by agent-id and user-id.
 */
export const agentsSimpleAgentThreadsPartialUpdate = <ThrowOnError extends boolean = false>(options: Options<AgentsSimpleAgentThreadsPartialUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<AgentsSimpleAgentThreadsPartialUpdateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/agents/simple-agent-threads/{id}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * ViewSet for managing SimpleAgentThreads with filtering by agent-id and user-id.
 */
export const agentsSimpleAgentThreadsUpdate = <ThrowOnError extends boolean = false>(options: Options<AgentsSimpleAgentThreadsUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<AgentsSimpleAgentThreadsUpdateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/agents/simple-agent-threads/{id}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * ViewSet for listing SimpleAgents without exposing configuration details.
 */
export const agentsSimpleAgentsList = <ThrowOnError extends boolean = false>(options?: Options<AgentsSimpleAgentsListData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<AgentsSimpleAgentsListResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/agents/simple-agents/',
        ...options
    });
};

/**
 * ViewSet for listing SimpleAgents without exposing configuration details.
 */
export const agentsSimpleAgentsRetrieve = <ThrowOnError extends boolean = false>(options: Options<AgentsSimpleAgentsRetrieveData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<AgentsSimpleAgentsRetrieveResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/agents/simple-agents/{id}/',
        ...options
    });
};

export const analyticsFeedbackCreate = <ThrowOnError extends boolean = false>(options: Options<AnalyticsFeedbackCreateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<AnalyticsFeedbackCreateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/analytics/feedback/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const analyticsSurveyList = <ThrowOnError extends boolean = false>(options?: Options<AnalyticsSurveyListData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<AnalyticsSurveyListResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/analytics/survey/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const analyticsSurveyCreate = <ThrowOnError extends boolean = false>(options: Options<AnalyticsSurveyCreateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<AnalyticsSurveyCreateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/analytics/survey/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const analyticsSurveyDestroy = <ThrowOnError extends boolean = false>(options: Options<AnalyticsSurveyDestroyData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<AnalyticsSurveyDestroyResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/analytics/survey/{id}/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const analyticsSurveyRetrieve = <ThrowOnError extends boolean = false>(options: Options<AnalyticsSurveyRetrieveData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<AnalyticsSurveyRetrieveResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/analytics/survey/{id}/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const analyticsSurveyPartialUpdate = <ThrowOnError extends boolean = false>(options: Options<AnalyticsSurveyPartialUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<AnalyticsSurveyPartialUpdateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/analytics/survey/{id}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const analyticsSurveyUpdate = <ThrowOnError extends boolean = false>(options: Options<AnalyticsSurveyUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<AnalyticsSurveyUpdateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/analytics/survey/{id}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Retrieve an AI Generated analysis for this survey results.
 */
export const analyticsSurveyAiAnalysisList = <ThrowOnError extends boolean = false>(options: Options<AnalyticsSurveyAiAnalysisListData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<AnalyticsSurveyAiAnalysisListResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/analytics/survey/{id}/ai-analysis/',
        ...options
    });
};

/**
 * Prepare survey email content with reference ID
 */
export const analyticsSurveyPrepareEmailContentRetrieve = <ThrowOnError extends boolean = false>(options: Options<AnalyticsSurveyPrepareEmailContentRetrieveData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<AnalyticsSurveyPrepareEmailContentRetrieveResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/analytics/survey/{id}/prepare-email-content/',
        ...options
    });
};

/**
 * Publish a survey.
 */
export const analyticsSurveyPublishCreate = <ThrowOnError extends boolean = false>(options: Options<AnalyticsSurveyPublishCreateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<AnalyticsSurveyPublishCreateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/analytics/survey/{id}/publish/',
        ...options
    });
};

/**
 * Retrieve results for a survey.
 */
export const analyticsSurveyResultsList = <ThrowOnError extends boolean = false>(options: Options<AnalyticsSurveyResultsListData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<AnalyticsSurveyResultsListResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/analytics/survey/{id}/results/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const appsAppsList = <ThrowOnError extends boolean = false>(options?: Options<AppsAppsListData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<AppsAppsListResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/apps/apps/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const appsAppsCreate = <ThrowOnError extends boolean = false>(options: Options<AppsAppsCreateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<AppsAppsCreateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/apps/apps/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const appsAppsDestroy = <ThrowOnError extends boolean = false>(options: Options<AppsAppsDestroyData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<AppsAppsDestroyResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/apps/apps/{id}/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const appsAppsRetrieve = <ThrowOnError extends boolean = false>(options: Options<AppsAppsRetrieveData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<AppsAppsRetrieveResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/apps/apps/{id}/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const appsAppsPartialUpdate = <ThrowOnError extends boolean = false>(options: Options<AppsAppsPartialUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<AppsAppsPartialUpdateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/apps/apps/{id}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const appsAppsUpdate = <ThrowOnError extends boolean = false>(options: Options<AppsAppsUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<AppsAppsUpdateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/apps/apps/{id}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Get a list of installed and deployed apps
 */
export const appsDeploymentsList = <ThrowOnError extends boolean = false>(options: Options<AppsDeploymentsListData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<AppsDeploymentsListResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/apps/deployments/',
        ...options
    });
};

/**
 * Invoke app deployments via API
 *
 * Apps are invoked sequentially based on `logical_order` of the installed app.
 */
export const appsDeploymentsInvokeCreate = <ThrowOnError extends boolean = false>(options: Options<AppsDeploymentsInvokeCreateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<AppsDeploymentsInvokeCreateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/apps/deployments/invoke/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Invoke a single app deployment via API by slug.
 */
export const appsDeploymentsInvokeCreate2 = <ThrowOnError extends boolean = false>(options: Options<AppsDeploymentsInvokeCreate2Data, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<AppsDeploymentsInvokeCreate2Response, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/apps/deployments/invoke/{slug}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const appsInstalledAppsList = <ThrowOnError extends boolean = false>(options?: Options<AppsInstalledAppsListData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<AppsInstalledAppsListResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/apps/installed-apps/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const appsInstalledAppsCreate = <ThrowOnError extends boolean = false>(options: Options<AppsInstalledAppsCreateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<AppsInstalledAppsCreateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/apps/installed-apps/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const appsInstalledAppsDestroy = <ThrowOnError extends boolean = false>(options: Options<AppsInstalledAppsDestroyData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<AppsInstalledAppsDestroyResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/apps/installed-apps/{id}/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const appsInstalledAppsRetrieve = <ThrowOnError extends boolean = false>(options: Options<AppsInstalledAppsRetrieveData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<AppsInstalledAppsRetrieveResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/apps/installed-apps/{id}/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const appsInstalledAppsPartialUpdate = <ThrowOnError extends boolean = false>(options: Options<AppsInstalledAppsPartialUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<AppsInstalledAppsPartialUpdateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/apps/installed-apps/{id}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const appsInstalledAppsUpdate = <ThrowOnError extends boolean = false>(options: Options<AppsInstalledAppsUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<AppsInstalledAppsUpdateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/apps/installed-apps/{id}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const campaignAssetsList = <ThrowOnError extends boolean = false>(options?: Options<CampaignAssetsListData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<CampaignAssetsListResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/campaign/assets/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const campaignAssetsCreate = <ThrowOnError extends boolean = false>(options: Options<CampaignAssetsCreateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CampaignAssetsCreateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/campaign/assets/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const campaignAssetsDestroy = <ThrowOnError extends boolean = false>(options: Options<CampaignAssetsDestroyData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<CampaignAssetsDestroyResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/campaign/assets/{id}/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const campaignAssetsRetrieve = <ThrowOnError extends boolean = false>(options: Options<CampaignAssetsRetrieveData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<CampaignAssetsRetrieveResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/campaign/assets/{id}/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const campaignAssetsPartialUpdate = <ThrowOnError extends boolean = false>(options: Options<CampaignAssetsPartialUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<CampaignAssetsPartialUpdateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/campaign/assets/{id}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const campaignAssetsUpdate = <ThrowOnError extends boolean = false>(options: Options<CampaignAssetsUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<CampaignAssetsUpdateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/campaign/assets/{id}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Enforces object-level permissions in ``rest_framework.viewsets.ViewSet``,
 * deriving the permission type from the particular action to be performed..
 *
 * As with ``rules.contrib.views.AutoPermissionRequiredMixin``, this only works when
 * model permissions are registered using ``rules.contrib.models.RulesModelMixin``.
 */
export const campaignAudiencesList = <ThrowOnError extends boolean = false>(options?: Options<CampaignAudiencesListData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<CampaignAudiencesListResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/campaign/audiences/',
        ...options
    });
};

/**
 * Enforces object-level permissions in ``rest_framework.viewsets.ViewSet``,
 * deriving the permission type from the particular action to be performed..
 *
 * As with ``rules.contrib.views.AutoPermissionRequiredMixin``, this only works when
 * model permissions are registered using ``rules.contrib.models.RulesModelMixin``.
 */
export const campaignAudiencesCreate = <ThrowOnError extends boolean = false>(options: Options<CampaignAudiencesCreateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CampaignAudiencesCreateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/campaign/audiences/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Enforces object-level permissions in ``rest_framework.viewsets.ViewSet``,
 * deriving the permission type from the particular action to be performed..
 *
 * As with ``rules.contrib.views.AutoPermissionRequiredMixin``, this only works when
 * model permissions are registered using ``rules.contrib.models.RulesModelMixin``.
 */
export const campaignAudiencesDestroy = <ThrowOnError extends boolean = false>(options: Options<CampaignAudiencesDestroyData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<CampaignAudiencesDestroyResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/campaign/audiences/{id}/',
        ...options
    });
};

/**
 * Enforces object-level permissions in ``rest_framework.viewsets.ViewSet``,
 * deriving the permission type from the particular action to be performed..
 *
 * As with ``rules.contrib.views.AutoPermissionRequiredMixin``, this only works when
 * model permissions are registered using ``rules.contrib.models.RulesModelMixin``.
 */
export const campaignAudiencesRetrieve = <ThrowOnError extends boolean = false>(options: Options<CampaignAudiencesRetrieveData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<CampaignAudiencesRetrieveResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/campaign/audiences/{id}/',
        ...options
    });
};

/**
 * Enforces object-level permissions in ``rest_framework.viewsets.ViewSet``,
 * deriving the permission type from the particular action to be performed..
 *
 * As with ``rules.contrib.views.AutoPermissionRequiredMixin``, this only works when
 * model permissions are registered using ``rules.contrib.models.RulesModelMixin``.
 */
export const campaignAudiencesPartialUpdate = <ThrowOnError extends boolean = false>(options: Options<CampaignAudiencesPartialUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<CampaignAudiencesPartialUpdateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/campaign/audiences/{id}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Enforces object-level permissions in ``rest_framework.viewsets.ViewSet``,
 * deriving the permission type from the particular action to be performed..
 *
 * As with ``rules.contrib.views.AutoPermissionRequiredMixin``, this only works when
 * model permissions are registered using ``rules.contrib.models.RulesModelMixin``.
 */
export const campaignAudiencesUpdate = <ThrowOnError extends boolean = false>(options: Options<CampaignAudiencesUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<CampaignAudiencesUpdateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/campaign/audiences/{id}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Enforces object-level permissions in ``rest_framework.viewsets.ViewSet``,
 * deriving the permission type from the particular action to be performed..
 *
 * As with ``rules.contrib.views.AutoPermissionRequiredMixin``, this only works when
 * model permissions are registered using ``rules.contrib.models.RulesModelMixin``.
 */
export const campaignAudiencesEstimateMatchRateCreate = <ThrowOnError extends boolean = false>(options: Options<CampaignAudiencesEstimateMatchRateCreateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/campaign/audiences/estimate-match-rate/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const campaignCampaignsList = <ThrowOnError extends boolean = false>(options?: Options<CampaignCampaignsListData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<CampaignCampaignsListResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/campaign/campaigns/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const campaignCampaignsCreate = <ThrowOnError extends boolean = false>(options: Options<CampaignCampaignsCreateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CampaignCampaignsCreateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/campaign/campaigns/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const campaignCampaignsDestroy = <ThrowOnError extends boolean = false>(options: Options<CampaignCampaignsDestroyData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<CampaignCampaignsDestroyResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/campaign/campaigns/{id}/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const campaignCampaignsRetrieve = <ThrowOnError extends boolean = false>(options: Options<CampaignCampaignsRetrieveData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<CampaignCampaignsRetrieveResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/campaign/campaigns/{id}/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const campaignCampaignsPartialUpdate = <ThrowOnError extends boolean = false>(options: Options<CampaignCampaignsPartialUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<CampaignCampaignsPartialUpdateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/campaign/campaigns/{id}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const campaignCampaignsUpdate = <ThrowOnError extends boolean = false>(options: Options<CampaignCampaignsUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<CampaignCampaignsUpdateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/campaign/campaigns/{id}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Enforces object-level permissions in ``rest_framework.viewsets.ViewSet``,
 * deriving the permission type from the particular action to be performed..
 *
 * As with ``rules.contrib.views.AutoPermissionRequiredMixin``, this only works when
 * model permissions are registered using ``rules.contrib.models.RulesModelMixin``.
 */
export const campaignContentTypesList = <ThrowOnError extends boolean = false>(options?: Options<CampaignContentTypesListData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<CampaignContentTypesListResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/campaign/content-types/',
        ...options
    });
};

/**
 * Enforces object-level permissions in ``rest_framework.viewsets.ViewSet``,
 * deriving the permission type from the particular action to be performed..
 *
 * As with ``rules.contrib.views.AutoPermissionRequiredMixin``, this only works when
 * model permissions are registered using ``rules.contrib.models.RulesModelMixin``.
 */
export const campaignContentTypesCreate = <ThrowOnError extends boolean = false>(options: Options<CampaignContentTypesCreateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CampaignContentTypesCreateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/campaign/content-types/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Enforces object-level permissions in ``rest_framework.viewsets.ViewSet``,
 * deriving the permission type from the particular action to be performed..
 *
 * As with ``rules.contrib.views.AutoPermissionRequiredMixin``, this only works when
 * model permissions are registered using ``rules.contrib.models.RulesModelMixin``.
 */
export const campaignContentTypesDestroy = <ThrowOnError extends boolean = false>(options: Options<CampaignContentTypesDestroyData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<CampaignContentTypesDestroyResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/campaign/content-types/{id}/',
        ...options
    });
};

/**
 * Enforces object-level permissions in ``rest_framework.viewsets.ViewSet``,
 * deriving the permission type from the particular action to be performed..
 *
 * As with ``rules.contrib.views.AutoPermissionRequiredMixin``, this only works when
 * model permissions are registered using ``rules.contrib.models.RulesModelMixin``.
 */
export const campaignContentTypesRetrieve = <ThrowOnError extends boolean = false>(options: Options<CampaignContentTypesRetrieveData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<CampaignContentTypesRetrieveResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/campaign/content-types/{id}/',
        ...options
    });
};

/**
 * Enforces object-level permissions in ``rest_framework.viewsets.ViewSet``,
 * deriving the permission type from the particular action to be performed..
 *
 * As with ``rules.contrib.views.AutoPermissionRequiredMixin``, this only works when
 * model permissions are registered using ``rules.contrib.models.RulesModelMixin``.
 */
export const campaignContentTypesPartialUpdate = <ThrowOnError extends boolean = false>(options: Options<CampaignContentTypesPartialUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<CampaignContentTypesPartialUpdateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/campaign/content-types/{id}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Enforces object-level permissions in ``rest_framework.viewsets.ViewSet``,
 * deriving the permission type from the particular action to be performed..
 *
 * As with ``rules.contrib.views.AutoPermissionRequiredMixin``, this only works when
 * model permissions are registered using ``rules.contrib.models.RulesModelMixin``.
 */
export const campaignContentTypesUpdate = <ThrowOnError extends boolean = false>(options: Options<CampaignContentTypesUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<CampaignContentTypesUpdateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/campaign/content-types/{id}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const configClientsList = <ThrowOnError extends boolean = false>(options?: Options<ConfigClientsListData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ConfigClientsListResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/config/clients/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const configClientsCreate = <ThrowOnError extends boolean = false>(options: Options<ConfigClientsCreateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ConfigClientsCreateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/config/clients/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const configClientsDestroy = <ThrowOnError extends boolean = false>(options: Options<ConfigClientsDestroyData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<ConfigClientsDestroyResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/config/clients/{id}/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const configClientsRetrieve = <ThrowOnError extends boolean = false>(options: Options<ConfigClientsRetrieveData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ConfigClientsRetrieveResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/config/clients/{id}/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const configClientsPartialUpdate = <ThrowOnError extends boolean = false>(options: Options<ConfigClientsPartialUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<ConfigClientsPartialUpdateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/config/clients/{id}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const configClientsUpdate = <ThrowOnError extends boolean = false>(options: Options<ConfigClientsUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<ConfigClientsUpdateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/config/clients/{id}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const configClientsDetailsRetrieve = <ThrowOnError extends boolean = false>(options: Options<ConfigClientsDetailsRetrieveData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ConfigClientsDetailsRetrieveResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/config/clients/{id}/details/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const configClientsLanguagesRetrieve = <ThrowOnError extends boolean = false>(options?: Options<ConfigClientsLanguagesRetrieveData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ConfigClientsLanguagesRetrieveResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/config/clients/languages/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const configClientsLookupRetrieve = <ThrowOnError extends boolean = false>(options: Options<ConfigClientsLookupRetrieveData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ConfigClientsLookupRetrieveResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/config/clients/lookup/{account}/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const configCouriersList = <ThrowOnError extends boolean = false>(options?: Options<ConfigCouriersListData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ConfigCouriersListResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/config/couriers/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const configCouriersCreate = <ThrowOnError extends boolean = false>(options: Options<ConfigCouriersCreateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ConfigCouriersCreateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/config/couriers/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const configCouriersDestroy = <ThrowOnError extends boolean = false>(options: Options<ConfigCouriersDestroyData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<ConfigCouriersDestroyResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/config/couriers/{id}/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const configCouriersRetrieve = <ThrowOnError extends boolean = false>(options: Options<ConfigCouriersRetrieveData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ConfigCouriersRetrieveResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/config/couriers/{id}/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const configCouriersPartialUpdate = <ThrowOnError extends boolean = false>(options: Options<ConfigCouriersPartialUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<ConfigCouriersPartialUpdateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/config/couriers/{id}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const configCouriersUpdate = <ThrowOnError extends boolean = false>(options: Options<ConfigCouriersUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<ConfigCouriersUpdateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/config/couriers/{id}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const configFilterFieldsList = <ThrowOnError extends boolean = false>(options?: Options<ConfigFilterFieldsListData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ConfigFilterFieldsListResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/config/filter-fields/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const configFilterFieldsCreate = <ThrowOnError extends boolean = false>(options: Options<ConfigFilterFieldsCreateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ConfigFilterFieldsCreateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/config/filter-fields/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const configFilterFieldsDestroy = <ThrowOnError extends boolean = false>(options: Options<ConfigFilterFieldsDestroyData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<ConfigFilterFieldsDestroyResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/config/filter-fields/{id}/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const configFilterFieldsRetrieve = <ThrowOnError extends boolean = false>(options: Options<ConfigFilterFieldsRetrieveData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ConfigFilterFieldsRetrieveResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/config/filter-fields/{id}/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const configFilterFieldsPartialUpdate = <ThrowOnError extends boolean = false>(options: Options<ConfigFilterFieldsPartialUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<ConfigFilterFieldsPartialUpdateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/config/filter-fields/{id}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const configFilterFieldsUpdate = <ThrowOnError extends boolean = false>(options: Options<ConfigFilterFieldsUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<ConfigFilterFieldsUpdateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/config/filter-fields/{id}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const configIntegrationsList = <ThrowOnError extends boolean = false>(options?: Options<ConfigIntegrationsListData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ConfigIntegrationsListResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/config/integrations/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const configIntegrationsCreate = <ThrowOnError extends boolean = false>(options: Options<ConfigIntegrationsCreateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ConfigIntegrationsCreateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/config/integrations/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const configIntegrationsDestroy = <ThrowOnError extends boolean = false>(options: Options<ConfigIntegrationsDestroyData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<ConfigIntegrationsDestroyResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/config/integrations/{id}/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const configIntegrationsRetrieve = <ThrowOnError extends boolean = false>(options: Options<ConfigIntegrationsRetrieveData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ConfigIntegrationsRetrieveResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/config/integrations/{id}/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const configIntegrationsPartialUpdate = <ThrowOnError extends boolean = false>(options: Options<ConfigIntegrationsPartialUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<ConfigIntegrationsPartialUpdateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/config/integrations/{id}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const configIntegrationsUpdate = <ThrowOnError extends boolean = false>(options: Options<ConfigIntegrationsUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<ConfigIntegrationsUpdateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/config/integrations/{id}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const configReferenceItemsList = <ThrowOnError extends boolean = false>(options?: Options<ConfigReferenceItemsListData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ConfigReferenceItemsListResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/config/reference-items/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const configReferenceItemsCreate = <ThrowOnError extends boolean = false>(options: Options<ConfigReferenceItemsCreateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ConfigReferenceItemsCreateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/config/reference-items/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const configReferenceItemsDestroy = <ThrowOnError extends boolean = false>(options: Options<ConfigReferenceItemsDestroyData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<ConfigReferenceItemsDestroyResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/config/reference-items/{id}/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const configReferenceItemsRetrieve = <ThrowOnError extends boolean = false>(options: Options<ConfigReferenceItemsRetrieveData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ConfigReferenceItemsRetrieveResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/config/reference-items/{id}/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const configReferenceItemsPartialUpdate = <ThrowOnError extends boolean = false>(options: Options<ConfigReferenceItemsPartialUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<ConfigReferenceItemsPartialUpdateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/config/reference-items/{id}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const configReferenceItemsUpdate = <ThrowOnError extends boolean = false>(options: Options<ConfigReferenceItemsUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<ConfigReferenceItemsUpdateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/config/reference-items/{id}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const configSmsAutoreplyConfigList = <ThrowOnError extends boolean = false>(options?: Options<ConfigSmsAutoreplyConfigListData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ConfigSmsAutoreplyConfigListResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/config/sms-autoreply-config/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const configSmsAutoreplyConfigCreate = <ThrowOnError extends boolean = false>(options: Options<ConfigSmsAutoreplyConfigCreateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ConfigSmsAutoreplyConfigCreateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/config/sms-autoreply-config/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const configSmsAutoreplyConfigDestroy = <ThrowOnError extends boolean = false>(options: Options<ConfigSmsAutoreplyConfigDestroyData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<ConfigSmsAutoreplyConfigDestroyResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/config/sms-autoreply-config/{id}/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const configSmsAutoreplyConfigRetrieve = <ThrowOnError extends boolean = false>(options: Options<ConfigSmsAutoreplyConfigRetrieveData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ConfigSmsAutoreplyConfigRetrieveResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/config/sms-autoreply-config/{id}/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const configSmsAutoreplyConfigPartialUpdate = <ThrowOnError extends boolean = false>(options: Options<ConfigSmsAutoreplyConfigPartialUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<ConfigSmsAutoreplyConfigPartialUpdateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/config/sms-autoreply-config/{id}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const configSmsAutoreplyConfigUpdate = <ThrowOnError extends boolean = false>(options: Options<ConfigSmsAutoreplyConfigUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<ConfigSmsAutoreplyConfigUpdateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/config/sms-autoreply-config/{id}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const configWhitelabelDomainConfigsList = <ThrowOnError extends boolean = false>(options?: Options<ConfigWhitelabelDomainConfigsListData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ConfigWhitelabelDomainConfigsListResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/config/whitelabel-domain-configs/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const configWhitelabelDomainConfigsRetrieve = <ThrowOnError extends boolean = false>(options: Options<ConfigWhitelabelDomainConfigsRetrieveData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ConfigWhitelabelDomainConfigsRetrieveResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/config/whitelabel-domain-configs/{id}/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const configWhitelistedDomainsList = <ThrowOnError extends boolean = false>(options?: Options<ConfigWhitelistedDomainsListData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ConfigWhitelistedDomainsListResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/config/whitelisted-domains/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const configWhitelistedDomainsCreate = <ThrowOnError extends boolean = false>(options: Options<ConfigWhitelistedDomainsCreateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ConfigWhitelistedDomainsCreateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/config/whitelisted-domains/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const configWhitelistedDomainsDestroy = <ThrowOnError extends boolean = false>(options: Options<ConfigWhitelistedDomainsDestroyData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<ConfigWhitelistedDomainsDestroyResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/config/whitelisted-domains/{id}/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const configWhitelistedDomainsBulkCreateCreate = <ThrowOnError extends boolean = false>(options: Options<ConfigWhitelistedDomainsBulkCreateCreateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ConfigWhitelistedDomainsBulkCreateCreateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/config/whitelisted-domains/bulk-create/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Check if a domain is whitelisted
 * Resource REST API
 */
export const configWhitelistedDomainsLookupRetrieve = <ThrowOnError extends boolean = false>(options: Options<ConfigWhitelistedDomainsLookupRetrieveData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ConfigWhitelistedDomainsLookupRetrieveResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/config/whitelisted-domains/lookup/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const importsList = <ThrowOnError extends boolean = false>(options?: Options<ImportsListData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ImportsListResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/imports/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const importsCreate = <ThrowOnError extends boolean = false>(options: Options<ImportsCreateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ImportsCreateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/imports/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const importsRetrieve = <ThrowOnError extends boolean = false>(options: Options<ImportsRetrieveData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ImportsRetrieveResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/imports/{id}/',
        ...options
    });
};

/**
 * Dismiss an in-app message content block.
 */
export const inAppMessageContentBlocksDismissPartialUpdate = <ThrowOnError extends boolean = false>(options: Options<InAppMessageContentBlocksDismissPartialUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<InAppMessageContentBlocksDismissPartialUpdateResponse, InAppMessageContentBlocksDismissPartialUpdateError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/in-app-message/content-blocks/{id}/dismiss/',
        ...options
    });
};

/**
 * Retrieve in-app message content blocks by location.
 */
export const inAppMessageContentBlocksByLocationList = <ThrowOnError extends boolean = false>(options: Options<InAppMessageContentBlocksByLocationListData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<InAppMessageContentBlocksByLocationListResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/in-app-message/content-blocks/by-location/{location}/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const journeyConfigurationsList = <ThrowOnError extends boolean = false>(options?: Options<JourneyConfigurationsListData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<JourneyConfigurationsListResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/journey/configurations/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const journeyConfigurationsCreate = <ThrowOnError extends boolean = false>(options: Options<JourneyConfigurationsCreateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<JourneyConfigurationsCreateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/journey/configurations/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const journeyConfigurationsDestroy = <ThrowOnError extends boolean = false>(options: Options<JourneyConfigurationsDestroyData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<JourneyConfigurationsDestroyResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/journey/configurations/{id}/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const journeyConfigurationsRetrieve = <ThrowOnError extends boolean = false>(options: Options<JourneyConfigurationsRetrieveData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<JourneyConfigurationsRetrieveResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/journey/configurations/{id}/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const journeyConfigurationsPartialUpdate = <ThrowOnError extends boolean = false>(options: Options<JourneyConfigurationsPartialUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<JourneyConfigurationsPartialUpdateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/journey/configurations/{id}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const journeyConfigurationsUpdate = <ThrowOnError extends boolean = false>(options: Options<JourneyConfigurationsUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<JourneyConfigurationsUpdateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/journey/configurations/{id}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const journeyConfigurationsPublishCreate = <ThrowOnError extends boolean = false>(options: Options<JourneyConfigurationsPublishCreateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<JourneyConfigurationsPublishCreateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/journey/configurations/{id}/publish/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const journeyConfigurationsFlowAnalysisRetrieve = <ThrowOnError extends boolean = false>(options: Options<JourneyConfigurationsFlowAnalysisRetrieveData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<JourneyConfigurationsFlowAnalysisRetrieveResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/journey/configurations/flow-analysis/{account_id}/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const journeyConfigurationsLookupRetrieve = <ThrowOnError extends boolean = false>(options: Options<JourneyConfigurationsLookupRetrieveData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<JourneyConfigurationsLookupRetrieveResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/journey/configurations/lookup/{account_id}/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const journeyEventsList = <ThrowOnError extends boolean = false>(options?: Options<JourneyEventsListData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<JourneyEventsListResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/journey/events/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const journeyEventsCreate = <ThrowOnError extends boolean = false>(options: Options<JourneyEventsCreateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<JourneyEventsCreateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/journey/events/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const journeyEventsDestroy = <ThrowOnError extends boolean = false>(options: Options<JourneyEventsDestroyData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<JourneyEventsDestroyResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/journey/events/{id}/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const journeyEventsRetrieve = <ThrowOnError extends boolean = false>(options: Options<JourneyEventsRetrieveData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<JourneyEventsRetrieveResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/journey/events/{id}/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const journeyEventsPartialUpdate = <ThrowOnError extends boolean = false>(options: Options<JourneyEventsPartialUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<JourneyEventsPartialUpdateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/journey/events/{id}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const journeyEventsUpdate = <ThrowOnError extends boolean = false>(options: Options<JourneyEventsUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<JourneyEventsUpdateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/journey/events/{id}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const journeyExperimentsList = <ThrowOnError extends boolean = false>(options?: Options<JourneyExperimentsListData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<JourneyExperimentsListResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/journey/experiments/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const journeyExperimentsCreate = <ThrowOnError extends boolean = false>(options: Options<JourneyExperimentsCreateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<JourneyExperimentsCreateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/journey/experiments/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const journeyExperimentsDestroy = <ThrowOnError extends boolean = false>(options: Options<JourneyExperimentsDestroyData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<JourneyExperimentsDestroyResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/journey/experiments/{id}/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const journeyExperimentsRetrieve = <ThrowOnError extends boolean = false>(options: Options<JourneyExperimentsRetrieveData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<JourneyExperimentsRetrieveResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/journey/experiments/{id}/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const journeyExperimentsPartialUpdate = <ThrowOnError extends boolean = false>(options: Options<JourneyExperimentsPartialUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<JourneyExperimentsPartialUpdateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/journey/experiments/{id}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const journeyExperimentsUpdate = <ThrowOnError extends boolean = false>(options: Options<JourneyExperimentsUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<JourneyExperimentsUpdateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/journey/experiments/{id}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const journeyExperimentsPublishCreate = <ThrowOnError extends boolean = false>(options: Options<JourneyExperimentsPublishCreateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<JourneyExperimentsPublishCreateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/journey/experiments/{id}/publish/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const journeyExperimentsResultsList = <ThrowOnError extends boolean = false>(options: Options<JourneyExperimentsResultsListData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<JourneyExperimentsResultsListResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/journey/experiments/{id}/results/',
        ...options
    });
};

/**
 * Custom action to update the winner of an Experiment and apply this variant's values
 * to the original messages.
 *
 * The variant that performed better will have its message attributes assigned to
 * the original message.
 */
export const journeyExperimentsWinnerVariantPartialUpdate = <ThrowOnError extends boolean = false>(options: Options<JourneyExperimentsWinnerVariantPartialUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<JourneyExperimentsWinnerVariantPartialUpdateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/journey/experiments/{id}/winner_variant/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const journeyFlowVisualizationsList = <ThrowOnError extends boolean = false>(options?: Options<JourneyFlowVisualizationsListData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<JourneyFlowVisualizationsListResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/journey/flow-visualizations/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const journeyFlowVisualizationsCreate = <ThrowOnError extends boolean = false>(options: Options<JourneyFlowVisualizationsCreateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<JourneyFlowVisualizationsCreateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/journey/flow-visualizations/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const journeyFlowVisualizationsDestroy = <ThrowOnError extends boolean = false>(options: Options<JourneyFlowVisualizationsDestroyData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<JourneyFlowVisualizationsDestroyResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/journey/flow-visualizations/{id}/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const journeyFlowVisualizationsRetrieve = <ThrowOnError extends boolean = false>(options: Options<JourneyFlowVisualizationsRetrieveData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<JourneyFlowVisualizationsRetrieveResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/journey/flow-visualizations/{id}/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const journeyFlowVisualizationsPartialUpdate = <ThrowOnError extends boolean = false>(options: Options<JourneyFlowVisualizationsPartialUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<JourneyFlowVisualizationsPartialUpdateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/journey/flow-visualizations/{id}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const journeyFlowVisualizationsUpdate = <ThrowOnError extends boolean = false>(options: Options<JourneyFlowVisualizationsUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<JourneyFlowVisualizationsUpdateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/journey/flow-visualizations/{id}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const journeyLayoutsList = <ThrowOnError extends boolean = false>(options?: Options<JourneyLayoutsListData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<JourneyLayoutsListResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/journey/layouts/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const journeyLayoutsCreate = <ThrowOnError extends boolean = false>(options: Options<JourneyLayoutsCreateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<JourneyLayoutsCreateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/journey/layouts/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const journeyLayoutsDestroy = <ThrowOnError extends boolean = false>(options: Options<JourneyLayoutsDestroyData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<JourneyLayoutsDestroyResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/journey/layouts/{id}/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const journeyLayoutsRetrieve = <ThrowOnError extends boolean = false>(options: Options<JourneyLayoutsRetrieveData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<JourneyLayoutsRetrieveResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/journey/layouts/{id}/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const journeyLayoutsPartialUpdate = <ThrowOnError extends boolean = false>(options: Options<JourneyLayoutsPartialUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<JourneyLayoutsPartialUpdateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/journey/layouts/{id}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const journeyLayoutsUpdate = <ThrowOnError extends boolean = false>(options: Options<JourneyLayoutsUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<JourneyLayoutsUpdateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/journey/layouts/{id}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const journeyLayoutsDetailsRetrieve = <ThrowOnError extends boolean = false>(options: Options<JourneyLayoutsDetailsRetrieveData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<JourneyLayoutsDetailsRetrieveResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/journey/layouts/{id}/details/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const journeyLayoutsEditorConfigRetrieve = <ThrowOnError extends boolean = false>(options: Options<JourneyLayoutsEditorConfigRetrieveData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<JourneyLayoutsEditorConfigRetrieveResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/journey/layouts/{id}/editor-config/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const journeyLayoutsHistoryRetrieve = <ThrowOnError extends boolean = false>(options: Options<JourneyLayoutsHistoryRetrieveData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<JourneyLayoutsHistoryRetrieveResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/journey/layouts/{id}/history/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const journeyLayoutsHistoryRetrieve2 = <ThrowOnError extends boolean = false>(options: Options<JourneyLayoutsHistoryRetrieve2Data, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<JourneyLayoutsHistoryRetrieve2Response, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/journey/layouts/{id}/history/{version_pk}/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const journeyLayoutsPublishCreate = <ThrowOnError extends boolean = false>(options: Options<JourneyLayoutsPublishCreateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<JourneyLayoutsPublishCreateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/journey/layouts/{id}/publish/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const journeyLayoutsRevertCreate = <ThrowOnError extends boolean = false>(options: Options<JourneyLayoutsRevertCreateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<JourneyLayoutsRevertCreateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/journey/layouts/{id}/revert/{version_pk}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const journeyLayoutsDeletedRetrieve = <ThrowOnError extends boolean = false>(options?: Options<JourneyLayoutsDeletedRetrieveData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<JourneyLayoutsDeletedRetrieveResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/journey/layouts/deleted/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const journeyMediasList = <ThrowOnError extends boolean = false>(options?: Options<JourneyMediasListData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<JourneyMediasListResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/journey/medias/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const journeyMediasCreate = <ThrowOnError extends boolean = false>(options: Options<JourneyMediasCreateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<JourneyMediasCreateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/journey/medias/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const journeyMediasDestroy = <ThrowOnError extends boolean = false>(options: Options<JourneyMediasDestroyData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<JourneyMediasDestroyResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/journey/medias/{id}/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const journeyMediasRetrieve = <ThrowOnError extends boolean = false>(options: Options<JourneyMediasRetrieveData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<JourneyMediasRetrieveResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/journey/medias/{id}/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const journeyMediasPartialUpdate = <ThrowOnError extends boolean = false>(options: Options<JourneyMediasPartialUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<JourneyMediasPartialUpdateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/journey/medias/{id}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const journeyMediasUpdate = <ThrowOnError extends boolean = false>(options: Options<JourneyMediasUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<JourneyMediasUpdateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/journey/medias/{id}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const journeyMessageTypesList = <ThrowOnError extends boolean = false>(options?: Options<JourneyMessageTypesListData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<JourneyMessageTypesListResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/journey/message-types/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const journeyMessageTypesCreate = <ThrowOnError extends boolean = false>(options: Options<JourneyMessageTypesCreateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<JourneyMessageTypesCreateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/journey/message-types/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const journeyMessageTypesDestroy = <ThrowOnError extends boolean = false>(options: Options<JourneyMessageTypesDestroyData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<JourneyMessageTypesDestroyResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/journey/message-types/{id}/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const journeyMessageTypesRetrieve = <ThrowOnError extends boolean = false>(options: Options<JourneyMessageTypesRetrieveData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<JourneyMessageTypesRetrieveResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/journey/message-types/{id}/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const journeyMessageTypesPartialUpdate = <ThrowOnError extends boolean = false>(options: Options<JourneyMessageTypesPartialUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<JourneyMessageTypesPartialUpdateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/journey/message-types/{id}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const journeyMessageTypesUpdate = <ThrowOnError extends boolean = false>(options: Options<JourneyMessageTypesUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<JourneyMessageTypesUpdateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/journey/message-types/{id}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const journeyMessageTypesAiGenerateCreate = <ThrowOnError extends boolean = false>(options: Options<JourneyMessageTypesAiGenerateCreateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<JourneyMessageTypesAiGenerateCreateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/journey/message-types/ai-generate/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const journeyMessagesList = <ThrowOnError extends boolean = false>(options?: Options<JourneyMessagesListData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<JourneyMessagesListResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/journey/messages/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const journeyMessagesCreate = <ThrowOnError extends boolean = false>(options: Options<JourneyMessagesCreateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<JourneyMessagesCreateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/journey/messages/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const journeyMessagesDestroy = <ThrowOnError extends boolean = false>(options: Options<JourneyMessagesDestroyData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<JourneyMessagesDestroyResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/journey/messages/{id}/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const journeyMessagesRetrieve = <ThrowOnError extends boolean = false>(options: Options<JourneyMessagesRetrieveData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<JourneyMessagesRetrieveResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/journey/messages/{id}/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const journeyMessagesPartialUpdate = <ThrowOnError extends boolean = false>(options: Options<JourneyMessagesPartialUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<JourneyMessagesPartialUpdateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/journey/messages/{id}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const journeyMessagesUpdate = <ThrowOnError extends boolean = false>(options: Options<JourneyMessagesUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<JourneyMessagesUpdateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/journey/messages/{id}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const journeyMessagesDetailsRetrieve = <ThrowOnError extends boolean = false>(options: Options<JourneyMessagesDetailsRetrieveData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<JourneyMessagesDetailsRetrieveResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/journey/messages/{id}/details/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const journeyMessagesEditorConfigRetrieve = <ThrowOnError extends boolean = false>(options: Options<JourneyMessagesEditorConfigRetrieveData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<JourneyMessagesEditorConfigRetrieveResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/journey/messages/{id}/editor-config/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const journeyMessagesHistoryRetrieve = <ThrowOnError extends boolean = false>(options: Options<JourneyMessagesHistoryRetrieveData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<JourneyMessagesHistoryRetrieveResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/journey/messages/{id}/history/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const journeyMessagesHistoryRetrieve2 = <ThrowOnError extends boolean = false>(options: Options<JourneyMessagesHistoryRetrieve2Data, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<JourneyMessagesHistoryRetrieve2Response, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/journey/messages/{id}/history/{version_pk}/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const journeyMessagesPublishCreate = <ThrowOnError extends boolean = false>(options: Options<JourneyMessagesPublishCreateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<JourneyMessagesPublishCreateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/journey/messages/{id}/publish/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const journeyMessagesRevertCreate = <ThrowOnError extends boolean = false>(options: Options<JourneyMessagesRevertCreateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<JourneyMessagesRevertCreateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/journey/messages/{id}/revert/{version_pk}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const journeyMessagesTestCreate = <ThrowOnError extends boolean = false>(options: Options<JourneyMessagesTestCreateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<JourneyMessagesTestCreateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/journey/messages/{id}/test/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const journeyMessagesTestWebhookCreate = <ThrowOnError extends boolean = false>(options: Options<JourneyMessagesTestWebhookCreateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/journey/messages/{id}/test_webhook/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const journeyMessagesAiTranslateCreate = <ThrowOnError extends boolean = false>(options: Options<JourneyMessagesAiTranslateCreateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<JourneyMessagesAiTranslateCreateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/journey/messages/ai-translate/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const journeyMessagesDeletedRetrieve = <ThrowOnError extends boolean = false>(options?: Options<JourneyMessagesDeletedRetrieveData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<JourneyMessagesDeletedRetrieveResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/journey/messages/deleted/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const journeyMessagesGenerateRetrieve = <ThrowOnError extends boolean = false>(options: Options<JourneyMessagesGenerateRetrieveData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<JourneyMessagesGenerateRetrieveResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/journey/messages/generate/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const journeyMessagesMigrateCreate = <ThrowOnError extends boolean = false>(options: Options<JourneyMessagesMigrateCreateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<JourneyMessagesMigrateCreateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/journey/messages/migrate/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const journeyPartialsList = <ThrowOnError extends boolean = false>(options?: Options<JourneyPartialsListData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<JourneyPartialsListResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/journey/partials/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const journeyPartialsCreate = <ThrowOnError extends boolean = false>(options: Options<JourneyPartialsCreateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<JourneyPartialsCreateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/journey/partials/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const journeyPartialsDestroy = <ThrowOnError extends boolean = false>(options: Options<JourneyPartialsDestroyData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<JourneyPartialsDestroyResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/journey/partials/{id}/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const journeyPartialsRetrieve = <ThrowOnError extends boolean = false>(options: Options<JourneyPartialsRetrieveData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<JourneyPartialsRetrieveResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/journey/partials/{id}/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const journeyPartialsPartialUpdate = <ThrowOnError extends boolean = false>(options: Options<JourneyPartialsPartialUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<JourneyPartialsPartialUpdateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/journey/partials/{id}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const journeyPartialsUpdate = <ThrowOnError extends boolean = false>(options: Options<JourneyPartialsUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<JourneyPartialsUpdateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/journey/partials/{id}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const journeyPartialsEditorConfigRetrieve = <ThrowOnError extends boolean = false>(options: Options<JourneyPartialsEditorConfigRetrieveData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<JourneyPartialsEditorConfigRetrieveResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/journey/partials/{id}/editor-config/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const journeyPartialsHistoryRetrieve = <ThrowOnError extends boolean = false>(options: Options<JourneyPartialsHistoryRetrieveData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<JourneyPartialsHistoryRetrieveResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/journey/partials/{id}/history/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const journeyPartialsHistoryRetrieve2 = <ThrowOnError extends boolean = false>(options: Options<JourneyPartialsHistoryRetrieve2Data, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<JourneyPartialsHistoryRetrieve2Response, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/journey/partials/{id}/history/{version_pk}/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const journeyPartialsPublishCreate = <ThrowOnError extends boolean = false>(options: Options<JourneyPartialsPublishCreateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<JourneyPartialsPublishCreateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/journey/partials/{id}/publish/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const journeyPartialsRevertCreate = <ThrowOnError extends boolean = false>(options: Options<JourneyPartialsRevertCreateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<JourneyPartialsRevertCreateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/journey/partials/{id}/revert/{version_pk}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const journeyPartialsDeletedRetrieve = <ThrowOnError extends boolean = false>(options?: Options<JourneyPartialsDeletedRetrieveData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<JourneyPartialsDeletedRetrieveResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/journey/partials/deleted/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const journeyPlaceholdersList = <ThrowOnError extends boolean = false>(options?: Options<JourneyPlaceholdersListData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<JourneyPlaceholdersListResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/journey/placeholders/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const journeyPlaceholdersCreate = <ThrowOnError extends boolean = false>(options: Options<JourneyPlaceholdersCreateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<JourneyPlaceholdersCreateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/journey/placeholders/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const journeyPlaceholdersDestroy = <ThrowOnError extends boolean = false>(options: Options<JourneyPlaceholdersDestroyData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<JourneyPlaceholdersDestroyResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/journey/placeholders/{id}/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const journeyPlaceholdersRetrieve = <ThrowOnError extends boolean = false>(options: Options<JourneyPlaceholdersRetrieveData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<JourneyPlaceholdersRetrieveResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/journey/placeholders/{id}/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const journeyPlaceholdersPartialUpdate = <ThrowOnError extends boolean = false>(options: Options<JourneyPlaceholdersPartialUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<JourneyPlaceholdersPartialUpdateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/journey/placeholders/{id}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const journeyPlaceholdersUpdate = <ThrowOnError extends boolean = false>(options: Options<JourneyPlaceholdersUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<JourneyPlaceholdersUpdateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/journey/placeholders/{id}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const journeySharedFiltersList = <ThrowOnError extends boolean = false>(options?: Options<JourneySharedFiltersListData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<JourneySharedFiltersListResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/journey/shared-filters/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const journeySharedFiltersCreate = <ThrowOnError extends boolean = false>(options: Options<JourneySharedFiltersCreateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<JourneySharedFiltersCreateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/journey/shared-filters/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const journeySharedFiltersDestroy = <ThrowOnError extends boolean = false>(options: Options<JourneySharedFiltersDestroyData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<JourneySharedFiltersDestroyResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/journey/shared-filters/{id}/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const journeySharedFiltersRetrieve = <ThrowOnError extends boolean = false>(options: Options<JourneySharedFiltersRetrieveData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<JourneySharedFiltersRetrieveResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/journey/shared-filters/{id}/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const journeySharedFiltersPartialUpdate = <ThrowOnError extends boolean = false>(options: Options<JourneySharedFiltersPartialUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<JourneySharedFiltersPartialUpdateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/journey/shared-filters/{id}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const journeySharedFiltersUpdate = <ThrowOnError extends boolean = false>(options: Options<JourneySharedFiltersUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<JourneySharedFiltersUpdateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/journey/shared-filters/{id}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const journeyTriggersList = <ThrowOnError extends boolean = false>(options?: Options<JourneyTriggersListData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<JourneyTriggersListResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/journey/triggers/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const journeyTriggersCreate = <ThrowOnError extends boolean = false>(options: Options<JourneyTriggersCreateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<JourneyTriggersCreateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/journey/triggers/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const journeyTriggersDestroy = <ThrowOnError extends boolean = false>(options: Options<JourneyTriggersDestroyData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<JourneyTriggersDestroyResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/journey/triggers/{id}/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const journeyTriggersRetrieve = <ThrowOnError extends boolean = false>(options: Options<JourneyTriggersRetrieveData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<JourneyTriggersRetrieveResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/journey/triggers/{id}/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const journeyTriggersPartialUpdate = <ThrowOnError extends boolean = false>(options: Options<JourneyTriggersPartialUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<JourneyTriggersPartialUpdateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/journey/triggers/{id}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const journeyTriggersUpdate = <ThrowOnError extends boolean = false>(options: Options<JourneyTriggersUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<JourneyTriggersUpdateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/journey/triggers/{id}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const notificationsNotificationList = <ThrowOnError extends boolean = false>(options?: Options<NotificationsNotificationListData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<NotificationsNotificationListResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/notifications/notification/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const notificationsNotificationCreate = <ThrowOnError extends boolean = false>(options: Options<NotificationsNotificationCreateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<NotificationsNotificationCreateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/notifications/notification/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const notificationsNotificationDestroy = <ThrowOnError extends boolean = false>(options: Options<NotificationsNotificationDestroyData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<NotificationsNotificationDestroyResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/notifications/notification/{id}/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const notificationsNotificationRetrieve = <ThrowOnError extends boolean = false>(options: Options<NotificationsNotificationRetrieveData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<NotificationsNotificationRetrieveResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/notifications/notification/{id}/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const notificationsNotificationPartialUpdate = <ThrowOnError extends boolean = false>(options: Options<NotificationsNotificationPartialUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<NotificationsNotificationPartialUpdateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/notifications/notification/{id}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const notificationsNotificationUpdate = <ThrowOnError extends boolean = false>(options: Options<NotificationsNotificationUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<NotificationsNotificationUpdateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/notifications/notification/{id}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const portalCustomAnalyticsList = <ThrowOnError extends boolean = false>(options?: Options<PortalCustomAnalyticsListData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<PortalCustomAnalyticsListResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/portal/custom-analytics/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const portalCustomAnalyticsCreate = <ThrowOnError extends boolean = false>(options: Options<PortalCustomAnalyticsCreateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PortalCustomAnalyticsCreateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/portal/custom-analytics/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const portalCustomAnalyticsDestroy = <ThrowOnError extends boolean = false>(options: Options<PortalCustomAnalyticsDestroyData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<PortalCustomAnalyticsDestroyResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/portal/custom-analytics/{id}/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const portalCustomAnalyticsRetrieve = <ThrowOnError extends boolean = false>(options: Options<PortalCustomAnalyticsRetrieveData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<PortalCustomAnalyticsRetrieveResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/portal/custom-analytics/{id}/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const portalCustomAnalyticsPartialUpdate = <ThrowOnError extends boolean = false>(options: Options<PortalCustomAnalyticsPartialUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<PortalCustomAnalyticsPartialUpdateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/portal/custom-analytics/{id}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const portalCustomAnalyticsUpdate = <ThrowOnError extends boolean = false>(options: Options<PortalCustomAnalyticsUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<PortalCustomAnalyticsUpdateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/portal/custom-analytics/{id}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Retrieve an iframe data for this custom analytics.
 */
export const portalCustomAnalyticsIframeRetrieve = <ThrowOnError extends boolean = false>(options: Options<PortalCustomAnalyticsIframeRetrieveData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<PortalCustomAnalyticsIframeRetrieveResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/portal/custom-analytics/iframe/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const portalCustomerPortalsList = <ThrowOnError extends boolean = false>(options?: Options<PortalCustomerPortalsListData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<PortalCustomerPortalsListResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/portal/customer-portals/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const portalCustomerPortalsCreate = <ThrowOnError extends boolean = false>(options: Options<PortalCustomerPortalsCreateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PortalCustomerPortalsCreateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/portal/customer-portals/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const portalCustomerPortalsDestroy = <ThrowOnError extends boolean = false>(options: Options<PortalCustomerPortalsDestroyData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<PortalCustomerPortalsDestroyResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/portal/customer-portals/{id}/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const portalCustomerPortalsRetrieve = <ThrowOnError extends boolean = false>(options: Options<PortalCustomerPortalsRetrieveData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<PortalCustomerPortalsRetrieveResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/portal/customer-portals/{id}/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const portalCustomerPortalsPartialUpdate = <ThrowOnError extends boolean = false>(options: Options<PortalCustomerPortalsPartialUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<PortalCustomerPortalsPartialUpdateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/portal/customer-portals/{id}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const portalCustomerPortalsUpdate = <ThrowOnError extends boolean = false>(options: Options<PortalCustomerPortalsUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<PortalCustomerPortalsUpdateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/portal/customer-portals/{id}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const portalDataProtectionRequestsList = <ThrowOnError extends boolean = false>(options?: Options<PortalDataProtectionRequestsListData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<PortalDataProtectionRequestsListResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/portal/data-protection-requests/',
        ...options
    });
};

/**
 * Creates the protection request and sends it to the backend
 */
export const portalDataProtectionRequestsCreate = <ThrowOnError extends boolean = false>(options: Options<PortalDataProtectionRequestsCreateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PortalDataProtectionRequestsCreateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/portal/data-protection-requests/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const portalDataProtectionRequestsDestroy = <ThrowOnError extends boolean = false>(options: Options<PortalDataProtectionRequestsDestroyData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<PortalDataProtectionRequestsDestroyResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/portal/data-protection-requests/{id}/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const portalDataProtectionRequestsRetrieve = <ThrowOnError extends boolean = false>(options: Options<PortalDataProtectionRequestsRetrieveData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<PortalDataProtectionRequestsRetrieveResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/portal/data-protection-requests/{id}/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const portalDataProtectionRequestsPartialUpdate = <ThrowOnError extends boolean = false>(options: Options<PortalDataProtectionRequestsPartialUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<PortalDataProtectionRequestsPartialUpdateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/portal/data-protection-requests/{id}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const portalDataProtectionRequestsUpdate = <ThrowOnError extends boolean = false>(options: Options<PortalDataProtectionRequestsUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<PortalDataProtectionRequestsUpdateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/portal/data-protection-requests/{id}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Creates the protection request and sends it to the backend
 */
export const portalDataProtectionRequestsBulkCreate = <ThrowOnError extends boolean = false>(options: Options<PortalDataProtectionRequestsBulkCreateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PortalDataProtectionRequestsBulkCreateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/portal/data-protection-requests/bulk/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Returns an PowerBI embed token for the authorized user and given account
 */
export const portalReportEmbedTokenTokenCreate = <ThrowOnError extends boolean = false>(options: Options<PortalReportEmbedTokenTokenCreateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PortalReportEmbedTokenTokenCreateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/portal/report-embed-token/token/{account_id}/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const portalReportsList = <ThrowOnError extends boolean = false>(options?: Options<PortalReportsListData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<PortalReportsListResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/portal/reports/',
        ...options
    });
};

/**
 * Overridden to add user id to report
 */
export const portalReportsCreate = <ThrowOnError extends boolean = false>(options: Options<PortalReportsCreateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PortalReportsCreateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/portal/reports/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const portalReportsDestroy = <ThrowOnError extends boolean = false>(options: Options<PortalReportsDestroyData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<PortalReportsDestroyResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/portal/reports/{id}/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const portalReportsRetrieve = <ThrowOnError extends boolean = false>(options: Options<PortalReportsRetrieveData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<PortalReportsRetrieveResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/portal/reports/{id}/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const portalReportsPartialUpdate = <ThrowOnError extends boolean = false>(options: Options<PortalReportsPartialUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<PortalReportsPartialUpdateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/portal/reports/{id}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const portalReportsUpdate = <ThrowOnError extends boolean = false>(options: Options<PortalReportsUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<PortalReportsUpdateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/portal/reports/{id}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const portalSharedObjectsList = <ThrowOnError extends boolean = false>(options?: Options<PortalSharedObjectsListData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<PortalSharedObjectsListResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/portal/shared-objects/',
        ...options
    });
};

/**
 * Overridden to add user id to shared object
 */
export const portalSharedObjectsCreate = <ThrowOnError extends boolean = false>(options: Options<PortalSharedObjectsCreateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PortalSharedObjectsCreateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/portal/shared-objects/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const portalSharedObjectsDestroy = <ThrowOnError extends boolean = false>(options: Options<PortalSharedObjectsDestroyData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<PortalSharedObjectsDestroyResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/portal/shared-objects/{id}/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const portalSharedObjectsRetrieve = <ThrowOnError extends boolean = false>(options: Options<PortalSharedObjectsRetrieveData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<PortalSharedObjectsRetrieveResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/portal/shared-objects/{id}/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const portalSharedObjectsPartialUpdate = <ThrowOnError extends boolean = false>(options: Options<PortalSharedObjectsPartialUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<PortalSharedObjectsPartialUpdateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/portal/shared-objects/{id}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const portalSharedObjectsUpdate = <ThrowOnError extends boolean = false>(options: Options<PortalSharedObjectsUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<PortalSharedObjectsUpdateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/portal/shared-objects/{id}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const promiseCourierServiceLevelsList = <ThrowOnError extends boolean = false>(options?: Options<PromiseCourierServiceLevelsListData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<PromiseCourierServiceLevelsListResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/promise/courier-service-levels/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const promiseCourierServiceLevelsCreate = <ThrowOnError extends boolean = false>(options: Options<PromiseCourierServiceLevelsCreateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PromiseCourierServiceLevelsCreateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/promise/courier-service-levels/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const promiseCourierServiceLevelsDestroy = <ThrowOnError extends boolean = false>(options: Options<PromiseCourierServiceLevelsDestroyData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<PromiseCourierServiceLevelsDestroyResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/promise/courier-service-levels/{id}/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const promiseCourierServiceLevelsRetrieve = <ThrowOnError extends boolean = false>(options: Options<PromiseCourierServiceLevelsRetrieveData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<PromiseCourierServiceLevelsRetrieveResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/promise/courier-service-levels/{id}/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const promiseCourierServiceLevelsPartialUpdate = <ThrowOnError extends boolean = false>(options: Options<PromiseCourierServiceLevelsPartialUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<PromiseCourierServiceLevelsPartialUpdateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/promise/courier-service-levels/{id}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const promiseCourierServiceLevelsUpdate = <ThrowOnError extends boolean = false>(options: Options<PromiseCourierServiceLevelsUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<PromiseCourierServiceLevelsUpdateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/promise/courier-service-levels/{id}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const promiseDeliveryMethodsList = <ThrowOnError extends boolean = false>(options?: Options<PromiseDeliveryMethodsListData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<PromiseDeliveryMethodsListResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/promise/delivery-methods/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const promiseDeliveryMethodsCreate = <ThrowOnError extends boolean = false>(options: Options<PromiseDeliveryMethodsCreateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PromiseDeliveryMethodsCreateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/promise/delivery-methods/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const promiseDeliveryMethodsDestroy = <ThrowOnError extends boolean = false>(options: Options<PromiseDeliveryMethodsDestroyData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<PromiseDeliveryMethodsDestroyResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/promise/delivery-methods/{id}/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const promiseDeliveryMethodsRetrieve = <ThrowOnError extends boolean = false>(options: Options<PromiseDeliveryMethodsRetrieveData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<PromiseDeliveryMethodsRetrieveResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/promise/delivery-methods/{id}/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const promiseDeliveryMethodsPartialUpdate = <ThrowOnError extends boolean = false>(options: Options<PromiseDeliveryMethodsPartialUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<PromiseDeliveryMethodsPartialUpdateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/promise/delivery-methods/{id}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const promiseDeliveryMethodsUpdate = <ThrowOnError extends boolean = false>(options: Options<PromiseDeliveryMethodsUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<PromiseDeliveryMethodsUpdateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/promise/delivery-methods/{id}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const promiseDeliveryPredictionServicesList = <ThrowOnError extends boolean = false>(options?: Options<PromiseDeliveryPredictionServicesListData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<PromiseDeliveryPredictionServicesListResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/promise/delivery-prediction-services/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const promiseDeliveryPredictionServicesCreate = <ThrowOnError extends boolean = false>(options: Options<PromiseDeliveryPredictionServicesCreateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PromiseDeliveryPredictionServicesCreateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/promise/delivery-prediction-services/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const promiseDeliveryPredictionServicesDestroy = <ThrowOnError extends boolean = false>(options: Options<PromiseDeliveryPredictionServicesDestroyData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<PromiseDeliveryPredictionServicesDestroyResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/promise/delivery-prediction-services/{id}/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const promiseDeliveryPredictionServicesRetrieve = <ThrowOnError extends boolean = false>(options: Options<PromiseDeliveryPredictionServicesRetrieveData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<PromiseDeliveryPredictionServicesRetrieveResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/promise/delivery-prediction-services/{id}/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const promiseDeliveryPredictionServicesPartialUpdate = <ThrowOnError extends boolean = false>(options: Options<PromiseDeliveryPredictionServicesPartialUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<PromiseDeliveryPredictionServicesPartialUpdateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/promise/delivery-prediction-services/{id}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const promiseDeliveryPredictionServicesUpdate = <ThrowOnError extends boolean = false>(options: Options<PromiseDeliveryPredictionServicesUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<PromiseDeliveryPredictionServicesUpdateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/promise/delivery-prediction-services/{id}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const promiseDeliveryPredictionServicesPublishCreate = <ThrowOnError extends boolean = false>(options: Options<PromiseDeliveryPredictionServicesPublishCreateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PromiseDeliveryPredictionServicesPublishCreateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/promise/delivery-prediction-services/{id}/publish/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const promiseDeliveryPredictionServicesPublishedRetrieve = <ThrowOnError extends boolean = false>(options?: Options<PromiseDeliveryPredictionServicesPublishedRetrieveData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<PromiseDeliveryPredictionServicesPublishedRetrieveResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/promise/delivery-prediction-services/published/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const promiseTrendingDelayConfigurationsList = <ThrowOnError extends boolean = false>(options?: Options<PromiseTrendingDelayConfigurationsListData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<PromiseTrendingDelayConfigurationsListResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/promise/trending-delay-configurations/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const promiseTrendingDelayConfigurationsCreate = <ThrowOnError extends boolean = false>(options: Options<PromiseTrendingDelayConfigurationsCreateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PromiseTrendingDelayConfigurationsCreateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/promise/trending-delay-configurations/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const promiseTrendingDelayConfigurationsDestroy = <ThrowOnError extends boolean = false>(options: Options<PromiseTrendingDelayConfigurationsDestroyData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<PromiseTrendingDelayConfigurationsDestroyResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/promise/trending-delay-configurations/{id}/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const promiseTrendingDelayConfigurationsRetrieve = <ThrowOnError extends boolean = false>(options: Options<PromiseTrendingDelayConfigurationsRetrieveData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<PromiseTrendingDelayConfigurationsRetrieveResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/promise/trending-delay-configurations/{id}/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const promiseTrendingDelayConfigurationsPartialUpdate = <ThrowOnError extends boolean = false>(options: Options<PromiseTrendingDelayConfigurationsPartialUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<PromiseTrendingDelayConfigurationsPartialUpdateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/promise/trending-delay-configurations/{id}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const promiseTrendingDelayConfigurationsUpdate = <ThrowOnError extends boolean = false>(options: Options<PromiseTrendingDelayConfigurationsUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<PromiseTrendingDelayConfigurationsUpdateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/promise/trending-delay-configurations/{id}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const promiseWarehousesList = <ThrowOnError extends boolean = false>(options?: Options<PromiseWarehousesListData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<PromiseWarehousesListResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/promise/warehouses/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const promiseWarehousesCreate = <ThrowOnError extends boolean = false>(options: Options<PromiseWarehousesCreateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PromiseWarehousesCreateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/promise/warehouses/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const promiseWarehousesDestroy = <ThrowOnError extends boolean = false>(options: Options<PromiseWarehousesDestroyData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<PromiseWarehousesDestroyResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/promise/warehouses/{id}/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const promiseWarehousesRetrieve = <ThrowOnError extends boolean = false>(options: Options<PromiseWarehousesRetrieveData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<PromiseWarehousesRetrieveResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/promise/warehouses/{id}/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const promiseWarehousesPartialUpdate = <ThrowOnError extends boolean = false>(options: Options<PromiseWarehousesPartialUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<PromiseWarehousesPartialUpdateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/promise/warehouses/{id}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const promiseWarehousesUpdate = <ThrowOnError extends boolean = false>(options: Options<PromiseWarehousesUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<PromiseWarehousesUpdateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/promise/warehouses/{id}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const returnsCourierApisList = <ThrowOnError extends boolean = false>(options?: Options<ReturnsCourierApisListData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ReturnsCourierApisListResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/returns/courier-apis/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const returnsCourierApisCreate = <ThrowOnError extends boolean = false>(options: Options<ReturnsCourierApisCreateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ReturnsCourierApisCreateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/returns/courier-apis/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const returnsCourierApisDestroy = <ThrowOnError extends boolean = false>(options: Options<ReturnsCourierApisDestroyData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<ReturnsCourierApisDestroyResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/returns/courier-apis/{id}/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const returnsCourierApisRetrieve = <ThrowOnError extends boolean = false>(options: Options<ReturnsCourierApisRetrieveData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ReturnsCourierApisRetrieveResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/returns/courier-apis/{id}/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const returnsCourierApisPartialUpdate = <ThrowOnError extends boolean = false>(options: Options<ReturnsCourierApisPartialUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<ReturnsCourierApisPartialUpdateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/returns/courier-apis/{id}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const returnsCourierApisUpdate = <ThrowOnError extends boolean = false>(options: Options<ReturnsCourierApisUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<ReturnsCourierApisUpdateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/returns/courier-apis/{id}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const returnsCourierApisSchemaRetrieve = <ThrowOnError extends boolean = false>(options: Options<ReturnsCourierApisSchemaRetrieveData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/returns/courier-apis/{id}/schema/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const returnsDocumentTemplatesList = <ThrowOnError extends boolean = false>(options?: Options<ReturnsDocumentTemplatesListData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ReturnsDocumentTemplatesListResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/returns/document-templates/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const returnsDocumentTemplatesCreate = <ThrowOnError extends boolean = false>(options: Options<ReturnsDocumentTemplatesCreateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ReturnsDocumentTemplatesCreateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/returns/document-templates/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const returnsDocumentTemplatesDestroy = <ThrowOnError extends boolean = false>(options: Options<ReturnsDocumentTemplatesDestroyData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<ReturnsDocumentTemplatesDestroyResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/returns/document-templates/{id}/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const returnsDocumentTemplatesRetrieve = <ThrowOnError extends boolean = false>(options: Options<ReturnsDocumentTemplatesRetrieveData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ReturnsDocumentTemplatesRetrieveResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/returns/document-templates/{id}/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const returnsDocumentTemplatesPartialUpdate = <ThrowOnError extends boolean = false>(options: Options<ReturnsDocumentTemplatesPartialUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<ReturnsDocumentTemplatesPartialUpdateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/returns/document-templates/{id}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const returnsDocumentTemplatesUpdate = <ThrowOnError extends boolean = false>(options: Options<ReturnsDocumentTemplatesUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<ReturnsDocumentTemplatesUpdateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/returns/document-templates/{id}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const returnsDocumentTemplatesPublishCreate = <ThrowOnError extends boolean = false>(options: Options<ReturnsDocumentTemplatesPublishCreateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ReturnsDocumentTemplatesPublishCreateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/returns/document-templates/{id}/publish/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const returnsDocumentTemplatesLookupRetrieve = <ThrowOnError extends boolean = false>(options: Options<ReturnsDocumentTemplatesLookupRetrieveData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ReturnsDocumentTemplatesLookupRetrieveResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/returns/document-templates/lookup/{key}/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const returnsOrderApisList = <ThrowOnError extends boolean = false>(options?: Options<ReturnsOrderApisListData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ReturnsOrderApisListResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/returns/order-apis/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const returnsOrderApisCreate = <ThrowOnError extends boolean = false>(options: Options<ReturnsOrderApisCreateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ReturnsOrderApisCreateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/returns/order-apis/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const returnsOrderApisDestroy = <ThrowOnError extends boolean = false>(options: Options<ReturnsOrderApisDestroyData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<ReturnsOrderApisDestroyResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/returns/order-apis/{id}/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const returnsOrderApisRetrieve = <ThrowOnError extends boolean = false>(options: Options<ReturnsOrderApisRetrieveData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ReturnsOrderApisRetrieveResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/returns/order-apis/{id}/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const returnsOrderApisPartialUpdate = <ThrowOnError extends boolean = false>(options: Options<ReturnsOrderApisPartialUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<ReturnsOrderApisPartialUpdateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/returns/order-apis/{id}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const returnsOrderApisUpdate = <ThrowOnError extends boolean = false>(options: Options<ReturnsOrderApisUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<ReturnsOrderApisUpdateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/returns/order-apis/{id}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const returnsOrderApisSchemaRetrieve = <ThrowOnError extends boolean = false>(options: Options<ReturnsOrderApisSchemaRetrieveData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/returns/order-apis/{id}/schema/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const returnsPortalsList = <ThrowOnError extends boolean = false>(options?: Options<ReturnsPortalsListData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ReturnsPortalsListResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/returns/portals/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const returnsPortalsCreate = <ThrowOnError extends boolean = false>(options: Options<ReturnsPortalsCreateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ReturnsPortalsCreateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/returns/portals/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const returnsPortalsDestroy = <ThrowOnError extends boolean = false>(options: Options<ReturnsPortalsDestroyData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<ReturnsPortalsDestroyResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/returns/portals/{id}/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const returnsPortalsRetrieve = <ThrowOnError extends boolean = false>(options: Options<ReturnsPortalsRetrieveData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ReturnsPortalsRetrieveResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/returns/portals/{id}/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const returnsPortalsPartialUpdate = <ThrowOnError extends boolean = false>(options: Options<ReturnsPortalsPartialUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<ReturnsPortalsPartialUpdateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/returns/portals/{id}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const returnsPortalsUpdate = <ThrowOnError extends boolean = false>(options: Options<ReturnsPortalsUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<ReturnsPortalsUpdateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/returns/portals/{id}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const returnsPortalsDetailsRetrieve = <ThrowOnError extends boolean = false>(options: Options<ReturnsPortalsDetailsRetrieveData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ReturnsPortalsDetailsRetrieveResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/returns/portals/{id}/details/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const returnsPortalsPublishCreate = <ThrowOnError extends boolean = false>(options: Options<ReturnsPortalsPublishCreateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ReturnsPortalsPublishCreateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/returns/portals/{id}/publish/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const returnsPortalsSchemaRetrieve = <ThrowOnError extends boolean = false>(options: Options<ReturnsPortalsSchemaRetrieveData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/returns/portals/{id}/schema/',
        ...options
    });
};

/**
 * Lookup a published configuration for a given locale and account_id
 */
export const returnsPortalsLookupRetrieve = <ThrowOnError extends boolean = false>(options: Options<ReturnsPortalsLookupRetrieveData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ReturnsPortalsLookupRetrieveResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/returns/portals/lookup/{key}/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const returnsReturnReasonsList = <ThrowOnError extends boolean = false>(options?: Options<ReturnsReturnReasonsListData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ReturnsReturnReasonsListResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/returns/return-reasons/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const returnsReturnReasonsCreate = <ThrowOnError extends boolean = false>(options: Options<ReturnsReturnReasonsCreateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ReturnsReturnReasonsCreateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/returns/return-reasons/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const returnsReturnReasonsDestroy = <ThrowOnError extends boolean = false>(options: Options<ReturnsReturnReasonsDestroyData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<ReturnsReturnReasonsDestroyResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/returns/return-reasons/{id}/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const returnsReturnReasonsRetrieve = <ThrowOnError extends boolean = false>(options: Options<ReturnsReturnReasonsRetrieveData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ReturnsReturnReasonsRetrieveResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/returns/return-reasons/{id}/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const returnsReturnReasonsPartialUpdate = <ThrowOnError extends boolean = false>(options: Options<ReturnsReturnReasonsPartialUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<ReturnsReturnReasonsPartialUpdateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/returns/return-reasons/{id}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const returnsReturnReasonsUpdate = <ThrowOnError extends boolean = false>(options: Options<ReturnsReturnReasonsUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<ReturnsReturnReasonsUpdateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/returns/return-reasons/{id}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const returnsReturnReasonsMoveToCreate = <ThrowOnError extends boolean = false>(options: Options<ReturnsReturnReasonsMoveToCreateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ReturnsReturnReasonsMoveToCreateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/returns/return-reasons/{id}/move_to/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const returnsReturnRegistrationsList = <ThrowOnError extends boolean = false>(options?: Options<ReturnsReturnRegistrationsListData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ReturnsReturnRegistrationsListResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/returns/return-registrations/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const returnsReturnRegistrationsCreate = <ThrowOnError extends boolean = false>(options: Options<ReturnsReturnRegistrationsCreateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ReturnsReturnRegistrationsCreateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/returns/return-registrations/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const returnsReturnRegistrationsDestroy = <ThrowOnError extends boolean = false>(options: Options<ReturnsReturnRegistrationsDestroyData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<ReturnsReturnRegistrationsDestroyResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/returns/return-registrations/{id}/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const returnsReturnRegistrationsRetrieve = <ThrowOnError extends boolean = false>(options: Options<ReturnsReturnRegistrationsRetrieveData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ReturnsReturnRegistrationsRetrieveResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/returns/return-registrations/{id}/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const returnsReturnRegistrationsPartialUpdate = <ThrowOnError extends boolean = false>(options: Options<ReturnsReturnRegistrationsPartialUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<ReturnsReturnRegistrationsPartialUpdateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/returns/return-registrations/{id}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const returnsReturnRegistrationsUpdate = <ThrowOnError extends boolean = false>(options: Options<ReturnsReturnRegistrationsUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<ReturnsReturnRegistrationsUpdateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/returns/return-registrations/{id}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Update Status of Return Registration
 * Resource REST API
 */
export const returnsReturnRegistrationsStatusCreate = <ThrowOnError extends boolean = false>(options: Options<ReturnsReturnRegistrationsStatusCreateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ReturnsReturnRegistrationsStatusCreateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/returns/return-registrations/{id}/status/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const returnsRulesList = <ThrowOnError extends boolean = false>(options?: Options<ReturnsRulesListData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ReturnsRulesListResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/returns/rules/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const returnsRulesCreate = <ThrowOnError extends boolean = false>(options: Options<ReturnsRulesCreateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ReturnsRulesCreateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/returns/rules/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const returnsRulesDestroy = <ThrowOnError extends boolean = false>(options: Options<ReturnsRulesDestroyData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<ReturnsRulesDestroyResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/returns/rules/{id}/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const returnsRulesRetrieve = <ThrowOnError extends boolean = false>(options: Options<ReturnsRulesRetrieveData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ReturnsRulesRetrieveResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/returns/rules/{id}/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const returnsRulesPartialUpdate = <ThrowOnError extends boolean = false>(options: Options<ReturnsRulesPartialUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<ReturnsRulesPartialUpdateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/returns/rules/{id}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const returnsRulesUpdate = <ThrowOnError extends boolean = false>(options: Options<ReturnsRulesUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<ReturnsRulesUpdateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/returns/rules/{id}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const returnsTranslationsList = <ThrowOnError extends boolean = false>(options?: Options<ReturnsTranslationsListData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ReturnsTranslationsListResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/returns/translations/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const returnsTranslationsCreate = <ThrowOnError extends boolean = false>(options: Options<ReturnsTranslationsCreateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ReturnsTranslationsCreateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/returns/translations/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const returnsTranslationsDestroy = <ThrowOnError extends boolean = false>(options: Options<ReturnsTranslationsDestroyData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<ReturnsTranslationsDestroyResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/returns/translations/{id}/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const returnsTranslationsRetrieve = <ThrowOnError extends boolean = false>(options: Options<ReturnsTranslationsRetrieveData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ReturnsTranslationsRetrieveResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/returns/translations/{id}/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const returnsTranslationsPartialUpdate = <ThrowOnError extends boolean = false>(options: Options<ReturnsTranslationsPartialUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<ReturnsTranslationsPartialUpdateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/returns/translations/{id}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const returnsTranslationsUpdate = <ThrowOnError extends boolean = false>(options: Options<ReturnsTranslationsUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<ReturnsTranslationsUpdateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/returns/translations/{id}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const returnsTranslationsSchemaRetrieve = <ThrowOnError extends boolean = false>(options: Options<ReturnsTranslationsSchemaRetrieveData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/returns/translations/{id}/schema/',
        ...options
    });
};

/**
 * ViewSet for retrieving published configurations.
 *
 * Provides read-only access to published configurations with:
 * - Filtering by content_type, key, and account
 * - Cursor-based pagination for efficient large dataset handling
 * - Option to retrieve only the latest configuration per object
 */
export const servicePublishedConfigurationsList = <ThrowOnError extends boolean = false>(options?: Options<ServicePublishedConfigurationsListData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ServicePublishedConfigurationsListResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/service/published-configurations/',
        ...options
    });
};

/**
 * ViewSet for retrieving published configurations.
 *
 * Provides read-only access to published configurations with:
 * - Filtering by content_type, key, and account
 * - Cursor-based pagination for efficient large dataset handling
 * - Option to retrieve only the latest configuration per object
 */
export const servicePublishedConfigurationsCreate = <ThrowOnError extends boolean = false>(options?: Options<ServicePublishedConfigurationsCreateData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<ServicePublishedConfigurationsCreateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/service/published-configurations/',
        ...options
    });
};

/**
 * ViewSet for retrieving published configurations.
 *
 * Provides read-only access to published configurations with:
 * - Filtering by content_type, key, and account
 * - Cursor-based pagination for efficient large dataset handling
 * - Option to retrieve only the latest configuration per object
 */
export const servicePublishedConfigurationsDestroy = <ThrowOnError extends boolean = false>(options: Options<ServicePublishedConfigurationsDestroyData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<ServicePublishedConfigurationsDestroyResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/service/published-configurations/{id}/',
        ...options
    });
};

/**
 * ViewSet for retrieving published configurations.
 *
 * Provides read-only access to published configurations with:
 * - Filtering by content_type, key, and account
 * - Cursor-based pagination for efficient large dataset handling
 * - Option to retrieve only the latest configuration per object
 */
export const servicePublishedConfigurationsRetrieve = <ThrowOnError extends boolean = false>(options: Options<ServicePublishedConfigurationsRetrieveData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ServicePublishedConfigurationsRetrieveResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/service/published-configurations/{id}/',
        ...options
    });
};

/**
 * ViewSet for retrieving published configurations.
 *
 * Provides read-only access to published configurations with:
 * - Filtering by content_type, key, and account
 * - Cursor-based pagination for efficient large dataset handling
 * - Option to retrieve only the latest configuration per object
 */
export const servicePublishedConfigurationsPartialUpdate = <ThrowOnError extends boolean = false>(options: Options<ServicePublishedConfigurationsPartialUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<ServicePublishedConfigurationsPartialUpdateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/service/published-configurations/{id}/',
        ...options
    });
};

/**
 * ViewSet for retrieving published configurations.
 *
 * Provides read-only access to published configurations with:
 * - Filtering by content_type, key, and account
 * - Cursor-based pagination for efficient large dataset handling
 * - Option to retrieve only the latest configuration per object
 */
export const servicePublishedConfigurationsUpdate = <ThrowOnError extends boolean = false>(options: Options<ServicePublishedConfigurationsUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<ServicePublishedConfigurationsUpdateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/service/published-configurations/{id}/',
        ...options
    });
};

export const serviceRecipesList = <ThrowOnError extends boolean = false>(options?: Options<ServiceRecipesListData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ServiceRecipesListResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/service/recipes/',
        ...options
    });
};

export const serviceRecipesRetrieve = <ThrowOnError extends boolean = false>(options: Options<ServiceRecipesRetrieveData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ServiceRecipesRetrieveResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/service/recipes/{id}/',
        ...options
    });
};

export const serviceRecipesApplyCreate = <ThrowOnError extends boolean = false>(options: Options<ServiceRecipesApplyCreateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ServiceRecipesApplyCreateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/service/recipes/{id}/apply/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const serviceRecipesApplicationsList = <ThrowOnError extends boolean = false>(options?: Options<ServiceRecipesApplicationsListData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ServiceRecipesApplicationsListResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/service/recipes/applications/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const serviceRecipesApplicationsRetrieve = <ThrowOnError extends boolean = false>(options: Options<ServiceRecipesApplicationsRetrieveData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ServiceRecipesApplicationsRetrieveResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/service/recipes/applications/{id}/',
        ...options
    });
};

/**
 * Publishes all the items created by the recipe application
 */
export const serviceRecipesApplicationsPublishCreate = <ThrowOnError extends boolean = false>(options: Options<ServiceRecipesApplicationsPublishCreateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ServiceRecipesApplicationsPublishCreateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/service/recipes/applications/{id}/publish/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const serviceServicesList = <ThrowOnError extends boolean = false>(options?: Options<ServiceServicesListData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ServiceServicesListResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/service/services/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const serviceServicesCreate = <ThrowOnError extends boolean = false>(options: Options<ServiceServicesCreateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ServiceServicesCreateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/service/services/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const serviceServicesDestroy = <ThrowOnError extends boolean = false>(options: Options<ServiceServicesDestroyData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<ServiceServicesDestroyResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/service/services/{id}/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const serviceServicesRetrieve = <ThrowOnError extends boolean = false>(options: Options<ServiceServicesRetrieveData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ServiceServicesRetrieveResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/service/services/{id}/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const serviceServicesPartialUpdate = <ThrowOnError extends boolean = false>(options: Options<ServiceServicesPartialUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<ServiceServicesPartialUpdateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/service/services/{id}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const serviceServicesUpdate = <ThrowOnError extends boolean = false>(options: Options<ServiceServicesUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<ServiceServicesUpdateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/service/services/{id}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const serviceServicesSchemaRetrieve = <ThrowOnError extends boolean = false>(options?: Options<ServiceServicesSchemaRetrieveData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ServiceServicesSchemaRetrieveResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/service/services/schema/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const testappTestList = <ThrowOnError extends boolean = false>(options?: Options<TestappTestListData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<TestappTestListResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/testapp/test/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const testappTestCreate = <ThrowOnError extends boolean = false>(options: Options<TestappTestCreateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<TestappTestCreateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/testapp/test/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const testappTestDestroy = <ThrowOnError extends boolean = false>(options: Options<TestappTestDestroyData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<TestappTestDestroyResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/testapp/test/{id}/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const testappTestRetrieve = <ThrowOnError extends boolean = false>(options: Options<TestappTestRetrieveData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<TestappTestRetrieveResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/testapp/test/{id}/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const testappTestPartialUpdate = <ThrowOnError extends boolean = false>(options: Options<TestappTestPartialUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<TestappTestPartialUpdateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/testapp/test/{id}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const testappTestUpdate = <ThrowOnError extends boolean = false>(options: Options<TestappTestUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<TestappTestUpdateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/testapp/test/{id}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const testappTestRaiseErrorRetrieve = <ThrowOnError extends boolean = false>(options?: Options<TestappTestRaiseErrorRetrieveData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<TestappTestRaiseErrorRetrieveResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/testapp/test/raise_error/',
        ...options
    });
};

export const trackEmailsList = <ThrowOnError extends boolean = false>(options?: Options<TrackEmailsListData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<TrackEmailsListResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/track/emails/',
        ...options
    });
};

export const trackEmailsRetrieve = <ThrowOnError extends boolean = false>(options: Options<TrackEmailsRetrieveData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<TrackEmailsRetrieveResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/track/emails/{id}/',
        ...options
    });
};

export const trackEventsList = <ThrowOnError extends boolean = false>(options?: Options<TrackEventsListData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<TrackEventsListResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/track/events/',
        ...options
    });
};

export const trackEventsRetrieve = <ThrowOnError extends boolean = false>(options: Options<TrackEventsRetrieveData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<TrackEventsRetrieveResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/track/events/{id}/',
        ...options
    });
};

export const trackEventsAvailableTypesRetrieve = <ThrowOnError extends boolean = false>(options?: Options<TrackEventsAvailableTypesRetrieveData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<TrackEventsAvailableTypesRetrieveResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/track/events/available_types/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const trackOrderStatusPagesList = <ThrowOnError extends boolean = false>(options?: Options<TrackOrderStatusPagesListData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<TrackOrderStatusPagesListResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/track/order-status-pages/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const trackOrderStatusPagesCreate = <ThrowOnError extends boolean = false>(options: Options<TrackOrderStatusPagesCreateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<TrackOrderStatusPagesCreateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/track/order-status-pages/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const trackOrderStatusPagesDestroy = <ThrowOnError extends boolean = false>(options: Options<TrackOrderStatusPagesDestroyData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<TrackOrderStatusPagesDestroyResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/track/order-status-pages/{id}/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const trackOrderStatusPagesRetrieve = <ThrowOnError extends boolean = false>(options: Options<TrackOrderStatusPagesRetrieveData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<TrackOrderStatusPagesRetrieveResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/track/order-status-pages/{id}/',
        ...options
    });
};

/**
 * Resource REST API
 */
export const trackOrderStatusPagesPartialUpdate = <ThrowOnError extends boolean = false>(options: Options<TrackOrderStatusPagesPartialUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<TrackOrderStatusPagesPartialUpdateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/track/order-status-pages/{id}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Resource REST API
 */
export const trackOrderStatusPagesUpdate = <ThrowOnError extends boolean = false>(options: Options<TrackOrderStatusPagesUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<TrackOrderStatusPagesUpdateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/track/order-status-pages/{id}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Lookup drop-off/pick-up locations for a courier, by location & distance.
 */
export const trackPlaceInfoList = <ThrowOnError extends boolean = false>(options?: Options<TrackPlaceInfoListData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<TrackPlaceInfoListResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/track/place-info/',
        ...options
    });
};

/**
 * Lookup drop-off/pick-up locations for a courier, by location & distance.
 */
export const trackPlaceInfoCreate = <ThrowOnError extends boolean = false>(options: Options<TrackPlaceInfoCreateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<TrackPlaceInfoCreateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/track/place-info/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Lookup drop-off/pick-up locations for a courier, by location & distance.
 */
export const trackPlaceInfoDestroy = <ThrowOnError extends boolean = false>(options: Options<TrackPlaceInfoDestroyData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<TrackPlaceInfoDestroyResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/track/place-info/{id}/',
        ...options
    });
};

/**
 * Lookup drop-off/pick-up locations for a courier, by location & distance.
 */
export const trackPlaceInfoRetrieve = <ThrowOnError extends boolean = false>(options: Options<TrackPlaceInfoRetrieveData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<TrackPlaceInfoRetrieveResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/track/place-info/{id}/',
        ...options
    });
};

/**
 * Lookup drop-off/pick-up locations for a courier, by location & distance.
 */
export const trackPlaceInfoPartialUpdate = <ThrowOnError extends boolean = false>(options: Options<TrackPlaceInfoPartialUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<TrackPlaceInfoPartialUpdateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/track/place-info/{id}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Lookup drop-off/pick-up locations for a courier, by location & distance.
 */
export const trackPlaceInfoUpdate = <ThrowOnError extends boolean = false>(options: Options<TrackPlaceInfoUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<TrackPlaceInfoUpdateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/track/place-info/{id}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Lookup places
 * Lookup drop-off/pick-up locations for a courier, by location & distance.
 */
export const trackPlaceInfoLookupCreate = <ThrowOnError extends boolean = false>(options: Options<TrackPlaceInfoLookupCreateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<TrackPlaceInfoLookupCreateResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/track/place-info/lookup/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const trackRecipientsList = <ThrowOnError extends boolean = false>(options?: Options<TrackRecipientsListData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<TrackRecipientsListResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/track/recipients/',
        ...options
    });
};

export const trackRecipientsRetrieve = <ThrowOnError extends boolean = false>(options: Options<TrackRecipientsRetrieveData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<TrackRecipientsRetrieveResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/track/recipients/{id}/',
        ...options
    });
};

export const trackTrackingsList = <ThrowOnError extends boolean = false>(options?: Options<TrackTrackingsListData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<TrackTrackingsListResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/track/trackings/',
        ...options
    });
};

export const trackTrackingsRetrieve = <ThrowOnError extends boolean = false>(options: Options<TrackTrackingsRetrieveData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<TrackTrackingsRetrieveResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v3/track/trackings/{id}/',
        ...options
    });
};